export const exampleFileName = 'your_file_name.raw';
export const exampleFileContent = `
JB,NM1222,DT04-06-2006,TM06:52:06
MO,AD0,UN2,SF1.0,EC0,EO0.0,AU0
SP,PN100000,N 5000.0,E 5000.0,EL0.0,--DELETE
--Data Collector Serial Number: 39242
SP,PN1,N 2401800.9288,E 1316179.3772,EL303.22,--TPK
SP,PN2,N 2402365.8983,E 1316616.7721,EL289.56,--TPK
SP,PN3,N 2402526.0521,E 1317205.9807,EL252.89,--TPK
SP,PN4,N 2402786.6999,E 1317597.1404,EL230.62,--MAG
SP,PN5,N 2402792.5192,E 1317899.4605,EL217.0,--MAG
SP,PN6,N 2402718.4023,E 1318306.2392,EL201.42,--TSPK
SP,PN7,N 2402759.2036,E 1318681.7664,EL184.29,--TSPK
SP,PN8,N 2402929.1327,E 1318833.4803,EL180.15,--MAG
SP,PN9,N 2402395.7937,E 1318583.5852,EL195.89,--TSPK
SP,PN10,N 2402210.6064,E 1318468.7564,EL206.16,--TSPK
SP,PN11,N 2402017.3768,E 1318342.528,EL211.17,--TSPK
SP,PN12,N 2401702.3284,E 1316881.6144,EL294.84,--MAG
SP,PN13,N 2401499.2229,E 1317087.5045,EL277.3,--TSPK
SP,PN14,N 2401624.705,E 1317413.7668,EL255.64,--TSPK
SP,PN15,N 2401274.7882,E 1316879.2651,EL269.13,--TSPK
SP,PN16,N 2401204.1447,E 1316661.9502,EL279.16,--TSPK
SP,PN17,N 2401808.7607,E 1317703.1469,EL238.82,--TSPK
SP,PN18,N 2401912.7111,E 1317834.3925,EL238.63,--TSPK
SP,PN19,N 2401913.0628,E 1318006.4915,EL226.76,--TSPK
SP,PN20,N 2401089.4167,E 1316287.6207,EL284.49,--TSPK
SP,PN21,N 2401247.0829,E 1315803.3741,EL305.37,--MAG
SP,PN22,N 2401081.5515,E 1315654.1773,EL301.23,--MAG
SP,PN23,N 2400898.7296,E 1315526.8969,EL304.8,--MAG
SP,PN24,N 2401097.5772,E 1316004.58,EL291.23,--TSPK
SP,PN25,N 2399465.3206,E 1317134.4223,EL354.0,--
SP,PN26,N 2399452.7876,E 1317157.5461,EL354.0,--
SP,PN30,N 2402358.4132,E 1316603.2675,EL289.62,--RB
SP,PN31,N 2402069.757,E 1316391.8423,EL297.79,--RS
SP,PN32,N 2402069.191,E 1316391.5501,EL297.93,--PK
SP,PN33,N 2402060.6877,E 1316386.6076,EL298.15,--MAG
SP,PN34,N 2401746.2033,E 1316156.7624,EL304.18,--RS
SP,PN35,N 2402755.7832,E 1317532.6666,EL233.61,--RS
SP,PN36,N 2402382.7379,E 1316628.3636,EL288.35,--RS
SP,PN501,N 2399383.1311,E 1317740.952,EL355.38,--nail
SP,PN502,N 2399450.8378,E 1317271.3528,EL354.21,--mag
SP,PN503,N 2399482.9164,E 1316613.3602,EL352.21,--MAG
SP,PN504,N 2400179.9681,E 1318265.7123,EL329.52,--T_SPK
SP,PN505,N 2400432.4987,E 1318505.8962,EL314.97,--T_SPK
SP,PN506,N 2400856.8431,E 1318769.0143,EL293.55,--NAIL
SP,PN507,N 2401697.5576,E 1316399.9154,EL301.38,--hub
SP,PN508,N 2401529.9043,E 1316720.5595,EL294.23,--hub
SP,PN509,N 2401797.5704,E 1317683.9751,EL239.67,--hub
SP,PN510,N 2401820.9223,E 1317300.6907,EL279.98,--hub
SP,PN511,N 2401926.1409,E 1316596.5578,EL296.6,--HUB
SP,PN512,N 2402190.9539,E 1316840.994,EL288.1,--HUB
SP,PN513,N 2402023.6775,E 1317072.5947,EL288.47,--HUB
SP,PN514,N 2401994.2709,E 1317377.0347,EL277.53,--HUB
SP,PN515,N 2402365.5847,E 1317608.3029,EL280.3,--STK5123 Corner C
SP,PN516,N 2402432.8065,E 1317829.8207,EL271.12,--HUB
SP,PN517,N 2402305.8884,E 1318008.7319,EL270.14,--HUB
SP,PN518,N 2402158.0942,E 1317914.4879,EL264.08,--HUB
SP,PN519,N 2401947.5427,E 1317604.5575,EL264.44,--tvshub
SP,PN520,N 2401039.6607,E 1315838.1503,EL294.16,--tvspk
SP,PN521,N 2400901.0057,E 1316061.447,EL293.26,--tvspk
SP,PN522,N 2400758.2906,E 1316184.686,EL302.7,--tspk
SP,PN523,N 2400647.7425,E 1316232.2708,EL308.9,--tspk
SP,PN524,N 2400482.2763,E 1316410.78,EL319.05,--TSPK
SP,PN525,N 2400507.5276,E 1316561.7817,EL315.9,--TSPK
SP,PN526,N 2400334.5095,E 1316743.3159,EL324.21,--TSPK
SP,PN527,N 2400207.9366,E 1316783.294,EL331.73,--TSPK
SP,PN528,N 2402553.7306,E 1316684.5678,EL296.18,--tmp_pt
SP,PN529,N 2401697.6706,E 1316399.902,EL301.4042,--STK529 new_507 F
SP,PN530,N 2401529.9816,E 1316720.5135,EL294.2469,--hubset
SP,PN531,N 2401697.6734,E 1316399.9032,EL301.3844,--hubset
SP,PN532,N 2402190.9485,E 1316841.0205,EL288.1086,--hubset
SP,PN533,N 2402023.628,E 1317072.612,EL288.4455,--hubset
SP,PN534,N 2401871.6798,E 1317304.3176,EL279.5986,--hubset
SP,PN535,N 2401759.4697,E 1317193.6811,EL284.8308,--hubset
SP,PN536,N 2401627.3517,E 1316362.8264,EL301.9918,--T_CAP
SP,PN537,N 2401891.8882,E 1316659.4421,EL296.4451,--T_CAP
SP,PN538,N 2402077.9259,E 1316869.1099,EL290.0829,--T_CAP
SP,PN539,N 2401931.9811,E 1317657.962,EL268.0992,--TCAP
SP,PN540,N 2402293.4357,E 1317849.2782,EL278.3722,--TVSCAP_540
SP,PN541,N 2401597.3531,E 1316944.5279,EL289.7434,--TCAP
SP,PN542,N 2402072.8251,E 1317321.4666,EL287.52,--REBAR
SP,PN1000,N 2402077.9345,E 1316869.1679,EL290.0424,--STK538 T_CAP FIL
SP,PN1001,N 2402035.7472,E 1316619.7182,EL295.6029,--RESECT
SP,PN5000,N 2401734.6764,E 1316255.6437,EL0.0,--LOD
SP,PN5001,N 2401780.3711,E 1316244.1773,EL0.0,--LOD
SP,PN5002,N 2401713.6548,E 1316195.883,EL0.0,--LOD
SP,PN5003,N 2401675.8738,E 1316297.0708,EL0.0,--LOD
SP,PN5004,N 2401634.314,E 1316333.5147,EL0.0,--LOD
SP,PN5005,N 2401569.9578,E 1316404.6608,EL0.0,--LOD
SP,PN5006,N 2401532.7059,E 1316448.0269,EL0.0,--LOD
SP,PN5007,N 2401535.8535,E 1316500.19,EL0.0,--LOD
SP,PN5008,N 2401483.7367,E 1316521.4697,EL0.0,--LOD
SP,PN5009,N 2401494.2158,E 1316568.8722,EL0.0,--LOD
SP,PN5010,N 2401447.7197,E 1316577.4397,EL0.0,--LOD
SP,PN5011,N 2401438.0256,E 1316590.0799,EL0.0,--LOD
SP,PN5012,N 2401435.1504,E 1316625.6529,EL0.0,--LOD
SP,PN5013,N 2401408.3354,E 1316630.236,EL0.0,--LOD
SP,PN5014,N 2401399.2188,E 1316644.0416,EL0.0,--LOD
SP,PN5015,N 2401400.5616,E 1316697.4347,EL0.0,--LOD
SP,PN5016,N 2401405.6615,E 1316703.2037,EL0.0,--LOD
SP,PN5017,N 2401370.2862,E 1316724.0193,EL0.0,--LOD
SP,PN5018,N 2401341.0598,E 1316760.1603,EL0.0,--LOD
SP,PN5019,N 2401317.8311,E 1316806.2365,EL0.0,--LOD
SP,PN5020,N 2401333.5583,E 1316871.9478,EL0.0,--LOD
SP,PN5021,N 2401370.8283,E 1316908.8834,EL0.0,--LOD
SP,PN5022,N 2401365.9726,E 1316949.0854,EL0.0,--LOD
SP,PN5023,N 2401419.2536,E 1317034.6431,EL0.0,--LOD
SP,PN5024,N 2401455.8181,E 1317054.5356,EL0.0,--LOD
SP,PN5025,N 2401486.6087,E 1317038.6449,EL0.0,--LOD
SP,PN5026,N 2401490.3907,E 1317074.2777,EL0.0,--LOD
SP,PN5027,N 2401460.3855,E 1317098.3075,EL0.0,--LOD
SP,PN5028,N 2401383.4913,E 1317088.0618,EL0.0,--LOD
SP,PN5029,N 2401390.1056,E 1317173.8728,EL0.0,--LOD
SP,PN5030,N 2401388.6763,E 1317213.3207,EL0.0,--LOD
SP,PN5031,N 2401384.2846,E 1317229.5504,EL0.0,--LOD
SP,PN5032,N 2401406.1083,E 1317282.5051,EL0.0,--LOD
SP,PN5033,N 2401465.528,E 1317352.3403,EL0.0,--LOD
SP,PN5034,N 2401500.1664,E 1317323.0185,EL0.0,--LOD
SP,PN5035,N 2401445.0245,E 1317256.8704,EL0.0,--LOD
SP,PN5036,N 2401420.1947,E 1317219.2722,EL0.0,--LOD
SP,PN5037,N 2401428.3298,E 1317209.4988,EL0.0,--LOD
SP,PN5038,N 2401464.873,E 1317196.5393,EL0.0,--LOD
SP,PN5039,N 2401536.1945,E 1317267.7495,EL0.0,--LOD
SP,PN5040,N 2401607.5161,E 1317338.9597,EL0.0,--LOD
SP,PN5041,N 2401657.3624,E 1317440.6214,EL0.0,--LOD
SP,PN5042,N 2401706.5958,E 1317535.2458,EL0.0,--LOD
SP,PN5043,N 2401700.7975,E 1317551.4468,EL0.0,--LOD
SP,PN5044,N 2401713.619,E 1317567.2877,EL0.0,--LOD
SP,PN5045,N 2401739.0769,E 1317588.2451,EL0.0,--LOD
SP,PN5046,N 2401764.1262,E 1317608.034,EL0.0,--LOD
SP,PN5047,N 2401803.9657,E 1317642.0963,EL0.0,--LOD
SP,PN5048,N 2401821.5496,E 1317645.0295,EL0.0,--LOD
SP,PN5049,N 2401842.6653,E 1317670.8767,EL0.0,--LOD
SP,PN5050,N 2401925.249,E 1317753.4947,EL0.0,--LOD
SP,PN5051,N 2402008.8522,E 1317813.0533,EL0.0,--LOD
SP,PN5052,N 2402019.6742,E 1317797.6314,EL0.0,--LOD
SP,PN5053,N 2401957.1342,E 1317733.478,EL0.0,--LOD
SP,PN5054,N 2401977.6258,E 1317704.1134,EL0.0,--LOD
SP,PN5055,N 2402050.7084,E 1317765.6049,EL0.0,--LOD
SP,PN5056,N 2402027.1943,E 1317841.6921,EL0.0,--LOD
SP,PN5057,N 2402020.1513,E 1317894.2918,EL0.0,--LOD
SP,PN5058,N 2402010.4259,E 1317908.7314,EL0.0,--LOD
SP,PN5059,N 2402022.3456,E 1317979.0821,EL0.0,--LOD
SP,PN5060,N 2402072.6623,E 1317994.4623,EL0.0,--LOD
SP,PN5061,N 2402103.3734,E 1318011.7504,EL0.0,--LOD
SP,PN5062,N 2402097.7362,E 1318043.0416,EL0.0,--LOD
SP,PN5063,N 2402106.6357,E 1318138.2369,EL0.0,--LOD
SP,PN5064,N 2402145.2423,E 1318161.0275,EL0.0,--LOD
SP,PN5065,N 2402208.6658,E 1318180.0283,EL0.0,--LOD
SP,PN5066,N 2402252.338,E 1318220.5574,EL0.0,--LOD
SP,PN5067,N 2402332.9199,E 1318265.4063,EL0.0,--LOD
SP,PN5068,N 2402405.8126,E 1318280.3499,EL0.0,--LOD
SP,PN5069,N 2402422.2492,E 1318266.4951,EL0.0,--LOD
SP,PN5070,N 2402419.52,E 1318201.266,EL0.0,--LOD
SP,PN5071,N 2402427.114,E 1318170.4297,EL0.0,--LOD
SP,PN5072,N 2402443.2063,E 1318153.0797,EL0.0,--LOD
SP,PN5073,N 2402492.5707,E 1318157.5342,EL0.0,--LOD
SP,PN5074,N 2402534.4053,E 1318104.7563,EL0.0,--LOD
SP,PN5075,N 2402543.8793,E 1318049.5636,EL0.0,--LOD
SP,PN5076,N 2402582.9706,E 1318050.5225,EL0.0,--LOD
SP,PN5077,N 2402625.9444,E 1318022.9375,EL0.0,--LOD
SP,PN5078,N 2402646.1093,E 1317983.5808,EL0.0,--LOD
SP,PN5079,N 2402651.7198,E 1317948.09,EL0.0,--LOD
SP,PN5080,N 2402646.0117,E 1317916.3532,EL0.0,--LOD
SP,PN5081,N 2402662.4218,E 1317864.5332,EL0.0,--LOD
SP,PN5082,N 2402668.03,E 1317821.9763,EL0.0,--LOD
SP,PN5083,N 2402647.9815,E 1317778.0752,EL0.0,--LOD
SP,PN5084,N 2402568.7134,E 1317724.1481,EL0.0,--LOD
SP,PN5085,N 2402503.9262,E 1317677.0708,EL0.0,--LOD
SP,PN5086,N 2402492.1213,E 1317676.3401,EL0.0,--LOD
SP,PN5087,N 2402456.1595,E 1317647.3333,EL0.0,--LOD
SP,PN5088,N 2402419.2049,E 1317608.2157,EL0.0,--LOD
SP,PN5089,N 2402471.3407,E 1317529.2128,EL0.0,--LOD
SP,PN5090,N 2402475.2177,E 1317512.1312,EL0.0,--LOD
SP,PN5091,N 2402452.4097,E 1317452.44,EL0.0,--LOD
SP,PN5092,N 2402392.9301,E 1317404.4749,EL0.0,--LOD
SP,PN5093,N 2402374.2051,E 1317398.5444,EL0.0,--LOD
SP,PN5094,N 2402348.3157,E 1317405.3363,EL0.0,--LOD
SP,PN5095,N 2402321.6147,E 1317443.6195,EL0.0,--LOD
SP,PN5096,N 2402292.2261,E 1317491.1636,EL0.0,--LOD
SP,PN5097,N 2402281.0209,E 1317508.1297,EL0.0,--LOD
SP,PN5098,N 2402224.4504,E 1317466.8751,EL0.0,--LOD
SP,PN5099,N 2402174.0034,E 1317429.9881,EL0.0,--LOD
SP,PN5100,N 2402105.3455,E 1317378.9545,EL0.0,--LOD
SP,PN5101,N 2402113.8512,E 1317366.4409,EL0.0,--LOD
SP,PN5102,N 2402150.9769,E 1317317.1833,EL0.0,--LOD
SP,PN5103,N 2402213.8441,E 1317228.8813,EL0.0,--LOD
SP,PN5104,N 2402280.2315,E 1317140.0991,EL0.0,--LOD
SP,PN5105,N 2402374.6896,E 1317010.6876,EL0.0,--LOD
SP,PN5106,N 2402413.3504,E 1316954.1765,EL0.0,--LOD
SP,PN5107,N 2402371.8962,E 1316785.5345,EL0.0,--LOD
SP,PN5108,N 2402330.7991,E 1316621.7123,EL0.0,--LOD
SP,PN5109,N 2402360.4424,E 1316581.3601,EL0.0,--LOD
SP,PN5110,N 2402356.1582,E 1316553.4103,EL0.0,--LOD
SP,PN5111,N 2402314.9816,E 1316609.4623,EL0.0,--LOD
SP,PN5112,N 2402230.9346,E 1316550.2611,EL0.0,--LOD
SP,PN5113,N 2402196.115,E 1316524.6688,EL0.0,--LOD
SP,PN5114,N 2402144.7784,E 1316486.1875,EL0.0,--LOD
SP,PN5115,N 2402099.3819,E 1316449.2548,EL0.0,--LOD
SP,PN5116,N 2402080.9272,E 1316432.385,EL0.0,--LOD
SP,PN5117,N 2401990.4396,E 1316374.6049,EL0.0,--LOD
SP,PN5118,N 2401930.0893,E 1316332.1306,EL0.0,--LOD
SP,PN5119,N 2401823.4383,E 1316252.0597,EL0.0,--LOD
SP,PN5120,N 2401728.3258,E 1316179.1835,EL0.0,--LOD
SP,PN5121,N 2402440.7591,E 1316923.1433,EL0.0,--Corner
SP,PN5122,N 2402106.4723,E 1317379.2353,EL0.0,--Corner
SP,PN5123,N 2402267.841,E 1317497.3883,EL0.0,--Corner
SP,PN5124,N 2402504.9504,E 1317173.5534,EL0.0,--Corner
SP,PN5125,N 2402618.2691,E 1317336.3417,EL0.0,--Corner
SP,PN5126,N 2402419.2049,E 1317608.2157,EL0.0,--Corner
SP,PN5127,N 2402773.6132,E 1317867.7107,EL0.0,--Corner
SP,PN5128,N 2402395.0902,E 1318341.0499,EL0.0,--Corner
SP,PN5129,N 2401813.7379,E 1317974.7937,EL0.0,--Corner
SP,PN5130,N 2401530.2531,E 1318341.5126,EL0.0,--Corner
SP,PN5131,N 2401353.1683,E 1318218.9615,EL0.0,--Corner
SP,PN5132,N 2400831.2521,E 1317361.4356,EL0.0,--Corner
SP,PN5133,N 2401288.8573,E 1316758.3584,EL0.0,--Corner
SP,PN5134,N 2401746.4625,E 1316155.2812,EL0.0,--Corner
SP,PN5135,N 2402304.0614,E 1318117.5933,EL0.0,--LAT12
SP,PN5136,N 2402315.4381,E 1318153.8399,EL0.0,--LAT12
SP,PN5137,N 2402321.345,E 1318129.0434,EL251.8,--10^SAN MH17
SP,PN5138,N 2402325.3096,E 1318132.0902,EL251.8,--15^SAN MH17
SP,PN5139,N 2402313.416,E 1318122.9499,EL251.8,--MH17
SP,PN5140,N 2402307.3225,E 1318130.8789,EL251.8,--10^SMH17
SP,PN5141,N 2402304.2758,E 1318134.8434,EL251.8,--15^SMH17
SP,PN5142,N 2402351.824,E 1318089.4071,EL0.0,--10^8"SAN
SP,PN5143,N 2402382.2884,E 1318049.7597,EL0.0,--10^8"SAN
SP,PN5144,N 2402412.7529,E 1318010.1123,EL0.0,--10^8"SAN
SP,PN5145,N 2402443.2173,E 1317970.4649,EL0.0,--10^8"SAN
SP,PN5146,N 2402397.1048,E 1318014.0646,EL0.0,--LAT11
SP,PN5147,N 2402418.6944,E 1318031.3295,EL0.0,--LAT11
SP,PN5148,N 2402456.4783,E 1317936.794,EL255.91,--SMH16
SP,PN5149,N 2402448.5488,E 1317930.7011,EL255.91,--10^SMH16
SP,PN5150,N 2402444.584,E 1317927.6547,EL255.91,--15^SMH16
SP,PN5151,N 2402464.4078,E 1317942.8869,EL255.91,--10^SMH16
SP,PN5152,N 2402468.3725,E 1317945.9333,EL255.91,--15^SMH16
SP,PN5153,N 2402461.3666,E 1317910.0165,EL0.0,--LAT10
SP,PN5154,N 2402492.8051,E 1317916.6824,EL0.0,--LAT10
SP,PN5155,N 2402479.8513,E 1317808.7608,EL0.0,--LAT9
SP,PN5156,N 2402510.0211,E 1317811.3469,EL0.0,--LAT9
SP,PN5157,N 2402475.6542,E 1317887.4353,EL0.0,--10^8" SAN
SP,PN5158,N 2402484.6335,E 1317838.2482,EL0.0,--10^8" SAN
SP,PN5159,N 2402483.3171,E 1317790.0915,EL262.02,--SMH15
SP,PN5160,N 2402498.0733,E 1317792.7853,EL262.02,--15^SMH15
SP,PN5161,N 2402493.1546,E 1317791.8873,EL262.02,--10^SMH15
SP,PN5162,N 2402473.4797,E 1317788.2956,EL262.02,--10^SMH15
SP,PN5163,N 2402468.561,E 1317787.3977,EL262.02,--15^SMH15
SP,PN5164,N 2402462.316,E 1317904.8161,EL0.0,--LAT15
SP,PN5165,N 2402446.8256,E 1317896.8441,EL0.0,--LAT15
SP,PN5166,N 2402475.0628,E 1317738.7901,EL0.0,--10^ 8"SAN
SP,PN5167,N 2402443.6781,E 1317682.5664,EL265.13,--SMH14
SP,PN5168,N 2402447.5353,E 1317693.0296,EL0.0,--LAT16
SP,PN5169,N 2402427.0153,E 1317702.9348,EL0.0,--LAT16
SP,PN5170,N 2402429.604,E 1317687.7548,EL265.13,--15^SMH14
SP,PN5171,N 2402434.2954,E 1317686.0254,EL265.13,--10^SMH14
SP,PN5172,N 2402453.0608,E 1317679.1075,EL265.13,--10^SMH14
SP,PN5173,N 2402457.7522,E 1317677.378,EL265.13,--15^SMH14
SP,PN5174,N 2402413.7657,E 1317642.5009,EL270.79,--10^ 8"SAN
SP,PN5175,N 2402376.4445,E 1317609.2273,EL0.0,--10^ 8"SAN
SP,PN5176,N 2402322.8801,E 1317574.8693,EL270.79,--SMH13
SP,PN5177,N 2402329.5348,E 1317567.4051,EL270.79,--10^ SMH13
SP,PN5178,N 2402332.8621,E 1317563.673,EL270.79,--15^SMH13
SP,PN5179,N 2402312.898,E 1317586.0657,EL270.79,--15^SMH13
SP,PN5180,N 2402316.2253,E 1317582.3335,EL270.79,--10^SMH13
SP,PN5181,N 2402404.1486,E 1317647.3241,EL0.0,--LAT?
SP,PN5182,N 2402427.2407,E 1317621.3937,EL0.0,--LAT?
SP,PN5183,N 2402337.9443,E 1317588.2998,EL0.0,--LAT8
SP,PN5184,N 2402353.7775,E 1317566.5072,EL0.0,--LAT8
SP,PN5185,N 2402326.8012,E 1317578.3652,EL0.0,--LAT17
SP,PN5186,N 2402310.4244,E 1317596.7343,EL0.0,--LAT17
SP,PN5187,N 2401875.303,E 1317259.5508,EL271.14,--10^SMH10
SP,PN5188,N 2401872.3491,E 1317263.585,EL271.14,--15^ SMH10
SP,PN5189,N 2401881.2106,E 1317251.4823,EL271.14,--SMH10
SP,PN5190,N 2401918.2205,E 1317217.8629,EL0.0,--10^8" SAN
SP,PN5191,N 2401947.7587,E 1317177.5207,EL0.0,--10^8" SAN
SP,PN5192,N 2401942.8002,E 1317167.3657,EL0.0,--LAT7
SP,PN5193,N 2401962.9713,E 1317182.1348,EL0.0,--LAT7
SP,PN5194,N 2401959.87,E 1317169.4433,EL271.89,--15'SMH9
SP,PN5195,N 2401955.8357,E 1317166.4894,EL271.89,--10^SMH9
SP,PN5196,N 2401939.6989,E 1317154.6741,EL271.89,--10^SMH9
SP,PN5197,N 2401935.6646,E 1317151.7203,EL271.89,--15^SMH9
SP,PN5198,N 2401952.0948,E 1317154.6293,EL0.0,--LAT20
SP,PN5199,N 2401931.9438,E 1317139.8748,EL0.0,--LAT20
SP,PN5200,N 2401986.5377,E 1317124.522,EL0.0,--10^8"SAN
SP,PN5201,N 2402016.0801,E 1317084.1829,EL0.0,--10^8"SAN
SP,PN5202,N 2402019.4072,E 1317062.7168,EL0.0,--LAT6
SP,PN5203,N 2402039.5888,E 1317077.4936,EL0.0,--LAT6
SP,PN5204,N 2402033.7562,E 1317043.124,EL0.0,--LAT21
SP,PN5205,N 2402013.5935,E 1317028.3609,EL0.0,--LAT21
SP,PN5206,N 2402045.6226,E 1317043.8438,EL0.0,--10^8"SAN
SP,PN5207,N 2402075.1651,E 1317003.5047,EL0.0,--10^8"SAN
SP,PN5208,N 2402096.8474,E 1316956.9735,EL0.0,--LAT5
SP,PN5209,N 2402117.2422,E 1316971.4375,EL0.0,--LAT5
SP,PN5210,N 2402104.7075,E 1316963.1656,EL0.0,--10^8"SAN
SP,PN5211,N 2401413.6229,E 1317166.0099,EL0.0,--cl path
SP,PN5212,N 2401423.3477,E 1317205.9976,EL0.0,--cl path
SP,PN5213,N 2401425.4138,E 1317224.9589,EL0.0,--cl path
SP,PN5214,N 2401425.4137,E 1317224.9644,EL0.0,--cl path
SP,PN5215,N 2401424.9077,E 1317246.6484,EL0.0,--cl path
SP,PN5216,N 2401435.8337,E 1317279.2213,EL0.0,--cl path
SP,PN5217,N 2401463.2717,E 1317310.5916,EL0.0,--cl path
SP,PN5218,N 2401494.1494,E 1317341.8897,EL0.0,--cl path
SP,PN5219,N 2401504.7153,E 1317352.5994,EL0.0,--cl path
SP,PN5220,N 2401549.3489,E 1317387.8727,EL0.0,--cl path
SP,PN5221,N 2401601.3026,E 1317446.8719,EL0.0,--cl path
SP,PN5222,N 2401635.2261,E 1317517.213,EL0.0,--cl path
SP,PN5223,N 2401667.8046,E 1317552.6785,EL0.0,--cl path
SP,PN5224,N 2401715.8849,E 1317561.4524,EL0.0,--cl path
SP,PN5225,N 2401728.6988,E 1317560.4634,EL0.0,--cl path
SP,PN5226,N 2401751.545,E 1317564.0907,EL0.0,--cl path
SP,PN5227,N 2401770.7537,E 1317576.6089,EL0.0,--cl path
SP,PN5228,N 2401777.6948,E 1317584.0386,EL0.0,--cl path
SP,PN5229,N 2401797.7313,E 1317615.882,EL0.0,--cl path
SP,PN5230,N 2401798.9702,E 1317624.8407,EL0.0,--cl path
SP,PN5231,N 2401791.4753,E 1317633.1776,EL0.0,--cl path
SP,PN5232,N 2401780.95,E 1317639.1832,EL0.0,--cl path
SP,PN5233,N 2401776.2396,E 1317670.7787,EL0.0,--cl path
SP,PN5234,N 2401791.8272,E 1317697.9059,EL0.0,--cl path
SP,PN5235,N 2401834.5895,E 1317748.9509,EL0.0,--cl path
SP,PN5236,N 2401853.3283,E 1317771.419,EL0.0,--cl path
SP,PN5237,N 2401877.4945,E 1317786.663,EL0.0,--cl path
SP,PN5238,N 2401923.0046,E 1317807.9196,EL0.0,--cl path
SP,PN5239,N 2401956.0085,E 1317832.7212,EL0.0,--cl path
SP,PN5240,N 2401985.7095,E 1317851.2454,EL0.0,--cl path
SP,PN5241,N 2402012.6597,E 1317842.9035,EL0.0,--cl path
SP,PN5242,N 2402026.4966,E 1317832.3738,EL0.0,--cl path
SP,PN5243,N 2402033.3456,E 1317833.1226,EL0.0,--cl path
SP,PN5244,N 2401814.1009,E 1316569.1664,EL291.31,--SMH 1.0
SP,PN5245,N 2401692.5022,E 1316579.7919,EL289.93,--SMH 2.0
SP,PN5246,N 2401546.827,E 1316729.901,EL286.42,--SMH 3.1
SP,PN5247,N 2401515.534,E 1316831.0334,EL282.34,--SMH 3.0 (DROP) O
SP,PN5248,N 2401582.4861,E 1316955.9938,EL281.45,--SMH 4.0
SP,PN5249,N 2402000.7252,E 1316697.4948,EL284.38,--SMH 6.0
SP,PN5250,N 2402099.9421,E 1316770.137,EL274.51,--SMH 7.0
SP,PN5251,N 2402125.515,E 1316917.829,EL273.58,--SMH 8.0
SP,PN5252,N 2401947.7673,E 1317160.5818,EL271.89,--SMH 9.0
SP,PN5253,N 2401881.2106,E 1317251.4823,EL271.14,--SMH 10.0
SP,PN5254,N 2402151.1504,E 1317449.1302,EL267.5,--SMH 11.0
SP,PN5255,N 2401478.3727,E 1317159.3401,EL261.42,--SMH 4.1
SP,PN5256,N 2401461.9614,E 1317180.8805,EL250.88,--SMH 5.0
SP,PN5257,N 2401615.1954,E 1317334.3128,EL248.55,--SMH 5.2
SP,PN5258,N 2401715.9193,E 1317534.9997,EL243.4,--SMH 12.0
SP,PN5259,N 2401933.8475,E 1317745.9141,EL241.7,--SMH 20.1
SP,PN5260,N 2402012.6924,E 1317803.4755,EL241.03,--SMH 20.0
SP,PN5261,N 2402038.2389,E 1317938.1812,EL240.16,--SMH 19.0
SP,PN5262,N 2402043.1991,E 1317968.2188,EL243.59,--SMH 18.0
SP,PN5263,N 2402313.416,E 1318122.9499,EL251.8,--SMH 17.0
SP,PN5264,N 2402456.4783,E 1317936.794,EL255.91,--SMH 16.0
SP,PN5265,N 2402483.3171,E 1317790.0915,EL257.69,--SMH 15.0
SP,PN5266,N 2402443.6781,E 1317682.5664,EL265.13,--SMH 14
SP,PN5267,N 2402322.8801,E 1317574.8693,EL270.79,--SMH 13.0
SP,PN5268,N 2402313.8567,E 1316627.34,EL275.98,--smh 7.1
SP,PN5269,N 2402358.9093,E 1316567.3094,EL276.54,--smh 7.2
SP,PN5270,N 2402583.5995,E 1316732.0585,EL278.6,--smh 7.3
SP,PN5271,N 2401389.5879,E 1317108.4134,EL251.6,--SMH 33.2
SP,PN5272,N 2401248.9316,E 1317212.0757,EL252.66,--SMH 33.1
SP,PN5273,N 2402137.6167,E 1316926.6917,EL273.58,--15^SMH8
SP,PN5274,N 2402133.5828,E 1316923.7375,EL273.58,--10^SMH8
SP,PN5275,N 2402125.515,E 1316917.829,EL273.58,--SMH8
SP,PN5276,N 2402117.4472,E 1316911.9205,EL273.58,--10^SMH8
SP,PN5277,N 2402113.4132,E 1316908.9663,EL273.58,--15^SMH8
SP,PN5278,N 2402126.6689,E 1316865.8807,EL0.0,--10^8"SAN
SP,PN5279,N 2402118.1384,E 1316816.6138,EL0.0,--10^8"SAN
SP,PN5280,N 2402124.1659,E 1316910.0603,EL0.0,--LAT4
SP,PN5281,N 2402147.8298,E 1316905.6266,EL0.0,--LAT4
SP,PN5282,N 2402120.9231,E 1316891.3096,EL0.0,--LAT?
SP,PN5283,N 2402099.0262,E 1316895.0797,EL0.0,--LAT?
SP,PN5284,N 2402117.5302,E 1316871.7139,EL0.0,--LAT?
SP,PN5285,N 2402101.9484,E 1316876.1977,EL0.0,--LAT?
SP,PN5286,N 2402110.1398,E 1316829.0319,EL0.0,--LAT3
SP,PN5287,N 2402142.587,E 1316808.6688,EL0.0,--LAT3
SP,PN5288,N 2402099.9421,E 1316770.137,EL274.51,--SMH7
SP,PN5289,N 2402109.7955,E 1316768.4309,EL274.51,--10^SMH7
SP,PN5290,N 2402114.7222,E 1316767.5778,EL274.51,--15^SMH7
SP,PN5291,N 2402085.1621,E 1316772.6962,EL274.51,--15^SMH7
SP,PN5292,N 2402090.0887,E 1316771.8431,EL274.51,--10^SMH7
SP,PN5293,N 2402076.3564,E 1316752.8686,EL0.0,--LAT2
SP,PN5294,N 2402091.529,E 1316733.6315,EL0.0,--LAT2
SP,PN5295,N 2402064.7081,E 1316731.9464,EL0.0,--10^8"SAN
SP,PN5296,N 2402024.3651,E 1316702.4092,EL0.0,--10^8"SAN
SP,PN5297,N 2402004.8556,E 1316700.5189,EL0.0,--LAT1
SP,PN5298,N 2402019.6242,E 1316680.3474,EL0.0,--LAT1
SP,PN5299,N 2402009.5864,E 1316685.392,EL284.38,--15^SMH6
SP,PN5300,N 2402381.5205,E 1318035.9718,EL253.95,--MP SAN
SP,PN5301,N 2402466.4711,E 1317869.5426,EL256.9,--MP SAN
SP,PN5302,N 2402463.4976,E 1317736.3289,EL263.68,--MP SAN
SP,PN5303,N 2402383.2791,E 1317628.7179,EL268.06,--MP SAN
SP,PN5304,N 2402016.1805,E 1317350.3063,EL269.42,--MP SAN
SP,PN5305,N 2401914.489,E 1317206.0321,EL271.53,--MP SAN
SP,PN5306,N 2402036.6303,E 1317039.1976,EL272.76,--MP SAN
SP,PN5307,N 2402112.7286,E 1316843.983,EL274.15,--MP SAN
SP,PN5308,N 2402049.5268,E 1316733.2252,EL282.98,--MP SAN
SP,PN5309,N 2402206.8994,E 1316698.7385,EL275.35,--MP SAN
SP,PN5310,N 2402336.383,E 1316597.3247,EL276.36,--MP SAN
SP,PN5311,N 2402471.2544,E 1316649.684,EL277.66,--MP SAN
SP,PN5312,N 2401753.3011,E 1316574.474,EL290.72,--MP SAN
SP,PN5313,N 2401619.6646,E 1316654.8465,EL288.27,--MP SAN
SP,PN5314,N 2401531.1805,E 1316780.4672,EL285.88,--MP SAN
SP,PN5315,N 2401549.0101,E 1316893.5136,EL282.0,--MP SAN
SP,PN5316,N 2401530.4294,E 1317057.6669,EL271.54,--MP SAN
SP,PN5317,N 2401538.5784,E 1317257.5967,EL249.82,--MP SAN
SP,PN5318,N 2401665.5573,E 1317434.6562,EL246.08,--MP SAN
SP,PN5319,N 2401824.8834,E 1317640.4569,EL242.65,--MP SAN
SP,PN5320,N 2401973.27,E 1317774.6948,EL241.46,--MP SAN
SP,PN5321,N 2402025.4724,E 1317870.8271,EL240.7,--MP SAN
SP,PN5322,N 2402042.499,E 1317597.5222,EL256.7,--MP SAN
SP,PN5323,N 2402178.1668,E 1318045.5037,EL247.83,--13 SAN LAT.
SP,PN5324,N 2402378.4444,E 1318017.6151,EL253.02,--INL B7
SP,PN5325,N 2402155.2553,E 1317839.1337,EL251.41,--DMH 8
SP,PN5326,N 2401932.0662,E 1317660.6524,EL250.0,--HW 9
SP,PN5327,N 2402081.6539,E 1317416.8363,EL263.5,--INL A29 DROP A25
SP,PN5328,N 2402006.6327,E 1316689.4263,EL284.38,--10^SMH6
SP,PN5329,N 2401994.8178,E 1316705.5634,EL284.38,--10^SMH6
SP,PN5330,N 2402267.6309,E 1317928.999,EL252.31,--MP STM
SP,PN5331,N 2402042.8798,E 1317749.2685,EL250.71,--MP STM
SP,PN5332,N 2401991.8641,E 1316709.5977,EL284.38,--15^SMH6
SP,PN5333,N 2402271.0638,E 1318063.6341,EL0.0,--LAT14
SP,PN5334,N 2402324.6555,E 1318108.3525,EL0.0,--LAT14
SP,PN5335,N 2402264.198,E 1318106.2902,EL0.0,--10^8"SAN
SP,PN5336,N 2402220.8081,E 1318081.4443,EL0.0,--10^8"SAN
SP,PN5337,N 2402177.4182,E 1318056.5985,EL0.0,--10^8"SAN
SP,PN5338,N 2402134.0283,E 1318031.7526,EL0.0,--10^8"SAN
SP,PN5339,N 2402090.6384,E 1318006.9068,EL0.0,--10^8"SAN
SP,PN5340,N 2402047.2485,E 1317982.0609,EL0.0,--10^8"SAN
SP,PN5341,N 2402172.743,E 1318056.557,EL0.0,--LAT13
SP,PN5342,N 2402178.1668,E 1318045.5037,EL0.0,--LAT13
SP,PN5343,N 2402415.0818,E 1316608.4967,EL277.1,--san\
SP,PN5344,N 2402527.427,E 1316690.8712,EL278.13,--san
SP,PN5345,N 2402583.5995,E 1316732.0585,EL283.07,--SMH 7.3
SP,PN5346,N 2402601.1079,E 1316708.5963,EL283.68,--san
SP,PN5347,N 2401951.4043,E 1317425.8589,EL256.0,--256 CONT
SP,PN5348,N 2401993.4144,E 1317457.0266,EL256.0,--256 CONT
SP,PN5349,N 2402021.6288,E 1317484.7593,EL256.0,--256 CONT
SP,PN5350,N 2402041.8235,E 1317502.2465,EL256.0,--256 CONT
SP,PN5351,N 2402045.2985,E 1317507.8008,EL256.0,--256 CONT
SP,PN5352,N 2402042.6899,E 1317521.8995,EL256.0,--256 CONT
SP,PN5353,N 2402034.2102,E 1317534.3384,EL256.0,--256 CONT
SP,PN5354,N 2402025.1327,E 1317558.2408,EL256.0,--256 CONT
SP,PN5355,N 2401996.9491,E 1317606.6161,EL256.0,--256 CONT
SP,PN5356,N 2401987.5027,E 1317631.4692,EL256.0,--256 CONT
SP,PN5357,N 2401945.994,E 1317666.6883,EL256.0,--256 CONT
SP,PN5358,N 2401930.4711,E 1317674.588,EL256.0,--256 CONT
SP,PN5359,N 2401911.2398,E 1317670.8867,EL256.0,--256 CONT
SP,PN5360,N 2401892.0697,E 1317652.689,EL256.0,--256 CONT
SP,PN5361,N 2401848.714,E 1317602.7929,EL256.0,--256 CONT
SP,PN5362,N 2401834.9656,E 1317582.2914,EL256.0,--256 CONT
SP,PN5363,N 2401808.0556,E 1317555.7407,EL256.0,--256 CONT
SP,PN5364,N 2401880.7601,E 1317656.3834,EL256.0,--256 CONT
SP,PN5365,N 2401878.9054,E 1317670.4992,EL256.0,--256 CONT
SP,PN5366,N 2401903.4813,E 1317693.2101,EL256.0,--256 CONT
SP,PN5367,N 2401934.7953,E 1317697.5555,EL256.0,--256 CONT
SP,PN5368,N 2401846.1191,E 1317616.5654,EL256.0,--256 CONT
SP,PN5369,N 2401830.7268,E 1317615.3964,EL256.0,--256 CONT
SP,PN5370,N 2401820.6773,E 1317601.2693,EL256.0,--256 CONT
SP,PN5371,N 2401817.9247,E 1317596.447,EL256.0,--256 CONT
SP,PN5372,N 2401759.5873,E 1317545.1857,EL256.0,--256 CONT
SP,PN5373,N 2401756.0865,E 1317526.0609,EL256.0,--256 CONT
SP,PN5374,N 2401059.3395,E 1315672.5993,EL-99999.0,--cl path
SP,PN5375,N 2401036.519,E 1315704.1614,EL-99999.0,--cl path
SP,PN5376,N 2401024.1106,E 1315751.4566,EL-99999.0,--cl path
SP,PN5377,N 2401016.0175,E 1315790.5866,EL-99999.0,--cl path
SP,PN5378,N 2400984.1876,E 1315815.5247,EL-99999.0,--cl path
SP,PN5379,N 2400952.0442,E 1315833.5216,EL-99999.0,--cl path
SP,PN5380,N 2400897.1354,E 1315888.2581,EL-99999.0,--cl path
SP,PN5381,N 2400855.245,E 1315953.8071,EL-99999.0,--cl path
SP,PN5382,N 2400812.426,E 1316018.3138,EL-99999.0,--cl path
SP,PN5383,N 2400761.986,E 1316077.2467,EL-99999.0,--cl path
SP,PN5384,N 2400715.2206,E 1316130.3164,EL-99999.0,--cl path
SP,PN5385,N 2400677.8686,E 1316190.3848,EL-99999.0,--cl path
SP,PN5386,N 2400625.0439,E 1316271.9086,EL-99999.0,--cl path
SP,PN5387,N 2400514.14,E 1316387.7898,EL-99999.0,--cl path
SP,PN5388,N 2400453.2945,E 1316467.1487,EL-99999.0,--cl path
SP,PN5389,N 2400392.4491,E 1316546.5075,EL-99999.0,--cl path
SP,PN5390,N 2400331.6036,E 1316625.8664,EL-99999.0,--cl path
SP,PN5391,N 2400270.7582,E 1316705.2253,EL-99999.0,--cl path
SP,PN5392,N 2400209.9127,E 1316784.5841,EL-99999.0,--cl path
SP,PN5393,N 2400156.5973,E 1316854.1218,EL-99999.0,--cl path
SP,PN5394,N 2400111.8313,E 1316887.7427,EL-99999.0,--cl path
SP,PN5395,N 2400056.1207,E 1316893.2829,EL-99999.0,--cl path x cl pat
SP,PN5396,N 2399994.2871,E 1316880.0192,EL-99999.0,--cl path
SP,PN5397,N 2399932.8838,E 1316865.0134,EL-99999.0,--cl path
SP,PN5398,N 2401820.8876,E 1317545.6519,EL-99999.0,--D1
SP,PN5399,N 2401765.0037,E 1317586.8419,EL247.44,--D2 (INV)
SP,PN5400,N 2399501.6646,E 1316526.6094,EL-99999.0,--LOD
SP,PN5401,N 2399517.1755,E 1316527.3262,EL-99999.0,--LOD
SP,PN5402,N 2399551.4606,E 1316556.368,EL-99999.0,--LOD
SP,PN5403,N 2399587.3668,E 1316591.6361,EL-99999.0,--LOD
SP,PN5404,N 2399586.5675,E 1316691.7127,EL-99999.0,--LOD
SP,PN5405,N 2399584.3503,E 1316791.7212,EL-99999.0,--LOD
SP,PN5406,N 2399587.1808,E 1316891.9718,EL-99999.0,--LOD
SP,PN5407,N 2399588.8011,E 1316992.1644,EL-99999.0,--LOD
SP,PN5408,N 2399590.4214,E 1317092.357,EL-99999.0,--LOD
SP,PN5409,N 2399587.6288,E 1317192.338,EL-99999.0,--LOD
SP,PN5410,N 2399583.3789,E 1317292.2491,EL-99999.0,--LOD
SP,PN5411,N 2399578.4088,E 1317392.1257,EL-99999.0,--LOD
SP,PN5412,N 2399572.9726,E 1317491.9799,EL-99999.0,--LOD
SP,PN5413,N 2399567.871,E 1317591.8502,EL-99999.0,--LOD
SP,PN5414,N 2399562.8028,E 1317691.722,EL-99999.0,--LOD
SP,PN5415,N 2399560.175,E 1317743.5066,EL-99999.0,--LOD
SP,PN5416,N 2399527.3986,E 1317780.5515,EL-99999.0,--LOD
SP,PN5417,N 2399406.6869,E 1317702.4518,EL-99999.0,--LOD
SP,PN5418,N 2399422.0401,E 1317650.616,EL-99999.0,--LOD
SP,PN5419,N 2399425.4751,E 1317585.0226,EL-99999.0,--LOD
SP,PN5420,N 2399430.7047,E 1317485.1585,EL-99999.0,--LOD
SP,PN5421,N 2399435.9344,E 1317385.2943,EL-99999.0,--LOD
SP,PN5422,N 2399441.1641,E 1317285.4302,EL-99999.0,--LOD
SP,PN5423,N 2399446.2557,E 1317185.5595,EL-99999.0,--LOD
SP,PN5424,N 2399451.1113,E 1317085.6774,EL-99999.0,--LOD
SP,PN5425,N 2399455.967,E 1316985.7953,EL-99999.0,--LOD
SP,PN5426,N 2399460.8226,E 1316885.9132,EL-99999.0,--LOD
SP,PN5427,N 2399465.6782,E 1316786.0312,EL-99999.0,--LOD
SP,PN5428,N 2399470.5338,E 1316686.1491,EL-99999.0,--LOD
SP,PN5429,N 2399475.4156,E 1316585.7291,EL-99999.0,--LOD
SP,PN5430,N 2402436.1266,E 1316612.0868,EL-99999.0,--LOD
SP,PN5431,N 2402428.5944,E 1316631.3664,EL-99999.0,--LOD
SP,PN5432,N 2402513.937,E 1316693.9862,EL-99999.0,--LOD
SP,PN5433,N 2402525.5898,E 1316677.7301,EL-99999.0,--LOD
SP,PN5434,N 2402585.6502,E 1316746.6055,EL-99999.0,--LOD
SP,PN5435,N 2402581.5579,E 1316718.7965,EL-99999.0,--LOD
SP,PN5436,N 2402616.4775,E 1316672.4363,EL-99999.0,--LOD
SP,PN5437,N 2402632.4527,E 1316684.4693,EL-99999.0,--LOD
SP,PN5438,N 2402059.171,E 1316384.232,EL0.0,--CL LOCKL @ 0+00
SP,PN5439,N 2402001.668,E 1316410.297,EL297.49,--0+55 ROW RT @ PT
SP,PN5440,N 2402051.693,E 1316446.923,EL297.49,--0+55 ROW LT @ PT
SP,PN5441,N 2401975.084,E 1316446.605,EL296.9,--1+00 ROW-RT
SP,PN5442,N 2402025.109,E 1316483.231,EL296.9,--1+00 ROW-LT
SP,PN5443,N 2401916.009,E 1316527.291,EL295.69,--2+00 ROW-RT
SP,PN5444,N 2401966.035,E 1316563.917,EL295.69,--2+00 ROW-LT
SP,PN5445,N 2401893.776,E 1316557.658,EL295.36,--2+27.64 ROW RT P
SP,PN5446,N 2401944.009,E 1316594.001,EL295.24,--2+37.28 ROW LT P
SP,PN5447,N 2401881.2106,E 1317251.4823,EL282.1,--0+00 CL APRIL DR
SP,PN5448,N 2401930.9199,E 1317225.9093,EL282.17,--0+50 ROW RT
SP,PN5449,N 2401891.5407,E 1317195.0559,EL282.19,--0+51.63 ROW LT
SP,PN5450,N 2401960.4582,E 1317185.5671,EL282.7,--1+00 ROW RT
SP,PN5451,N 2401920.116,E 1317156.0288,EL282.7,--1+00 ROW LT
SP,PN5452,N 2402019.5347,E 1317104.8827,EL283.76,--2+00 ROW RT
SP,PN5453,N 2401979.1925,E 1317075.3445,EL283.76,--2+00 ROW LT
SP,PN5454,N 2402078.6112,E 1317024.1983,EL284.81,--3+00 ROW RT
SP,PN5455,N 2402038.269,E 1316994.6601,EL284.81,--3+00 ROW LT
SP,PN5456,N 2402118.5411,E 1316969.6635,EL285.53,--3+67.59 ROW RT
SP,PN5457,N 2402078.1986,E 1316940.1257,EL285.53,--3+67.59 ROW LT
SP,PN5458,N 2402137.4221,E 1316936.9882,EL285.9,--4+00 ROW RT
SP,PN5459,N 2402091.685,E 1316916.7862,EL285.9,--4+00 ROW LT
SP,PN5460,N 2402151.7457,E 1316880.719,EL286.95,--4+50 ROW RT
SP,PN5461,N 2402101.9162,E 1316876.5939,EL286.95,--4+50 ROW LT
SP,PN5462,N 2402146.87,E 1316822.8604,EL288.07,--5+00 ROW RT
SP,PN5463,N 2402098.4335,E 1316835.2664,EL288.07,--5+00 ROW LT
SP,PN5464,N 2402123.3316,E 1316769.7819,EL289.18,--5+50 ROW RT
SP,PN5465,N 2402081.6204,E 1316797.3531,EL289.18,--5+50 ROW LT
SP,PN5466,N 2402083.7219,E 1316727.3266,EL290.29,--6+00 ROW RT
SP,PN5467,N 2402053.3277,E 1316767.0279,EL290.29,--6+00 ROW LT
SP,PN5468,N 2402002.6281,E 1316667.9037,EL292.52,--7+00 ROW RT
SP,PN5469,N 2401973.0909,E 1316708.2466,EL292.52,--7+00 ROW LT
SP,PN5470,N 2401949.4078,E 1316628.9381,EL293.98,--7+65.96 ROW RT
SP,PN5471,N 2401892.405,E 1316649.1721,EL294.74,--8+00 ROW LT
SP,PN5472,N 2401839.0719,E 1316610.1239,EL295.8,--8+66.10 ROW LT
SP,PN5473,N 2401860.0539,E 1316563.899,EL295.9,--8+75 ROW RT
SP,PN5474,N 2401834.3395,E 1316550.2061,EL296.21,--9+00 ROW RT
SP,PN5475,N 2401814.5938,E 1316596.142,EL296.21,--9+00 ROW LT
SP,PN5476,N 2401777.9306,E 1316536.4432,EL296.83,--9+50 ROW RT
SP,PN5477,N 2401774.3017,E 1316586.3113,EL296.83,--9+50 ROW LT
SP,PN5478,N 2401720.1234,E 1316541.8946,EL297.26,--10+00 ROW RT
SP,PN5479,N 2401733.0108,E 1316590.2052,EL297.26,--10+00 ROW LT
SP,PN5480,N 2401667.2818,E 1316565.9601,EL296.89,--10+50 ROW RT
SP,PN5481,N 2401695.2668,E 1316607.3949,EL296.89,--10+50 ROW LT
SP,PN5482,N 2401625.3343,E 1316605.8358,EL296.14,--11+00 ROW RT
SP,PN5483,N 2401665.1063,E 1316636.1374,EL296.14,--11+00 ROW LT
SP,PN5484,N 2401564.731,E 1316685.3798,EL294.64,--12+00 ROW RT
SP,PN5485,N 2401604.503,E 1316715.6814,EL294.64,--12+00 ROW LT
SP,PN5486,N 2401533.9037,E 1316726.1146,EL293.89,--12+50 ROW RT
SP,PN5487,N 2401574.955,E 1316754.6591,EL293.89,--12+50 ROW LT
SP,PN5488,N 2401509.1237,E 1316778.625,EL293.14,--13+00 ROW RT
SP,PN5489,N 2401557.255,E 1316792.1665,EL293.14,--13+00 ROW LT
SP,PN5490,N 2401502.8887,E 1316836.3529,EL292.39,--13+50 ROW RT
SP,PN5491,N 2401552.8015,E 1316833.4007,EL292.39,--13+50 ROW LT
SP,PN5492,N 2401515.8852,E 1316892.9433,EL291.64,--14+00 ROW RT
SP,PN5493,N 2401562.0847,E 1316873.8224,EL291.64,--14+00 ROW LT
SP,PN5494,N 2401546.6825,E 1316942.1665,EL290.89,--14+50 ROW RT
SP,PN5495,N 2401584.0827,E 1316908.9818,EL290.89,--14+50 ROW LT
SP,PN5496,N 2401588.1538,E 1316977.8894,EL290.14,--15+00 ROW RT
SP,PN5497,N 2401618.4554,E 1316938.1174,EL290.14,--15+00 ROW LT
SP,PN5498,N 2401627.9258,E 1317008.191,EL289.39,--15+50 ROW RT
SP,PN5499,N 2401658.2274,E 1316968.419,EL289.39,--15+50 ROW LT
SP,PN5500,N 2401664.7477,E 1317037.6429,EL288.49,--16+00 ROW RT
SP,PN5501,N 2401699.3331,E 1317001.5341,EL288.49,--16+00 ROW LT
SP,PN5502,N 2401692.859,E 1317072.2225,EL287.45,--16+50 ROW RT
SP,PN5503,N 2401734.3007,E 1317044.2479,EL287.45,--16+50 ROW LT
SP,PN5504,N 2401720.8336,E 1317113.6643,EL286.41,--17+00 ROW RT
SP,PN5505,N 2401762.2754,E 1317085.6896,EL286.41,--17+00 ROW LT
SP,PN5506,N 2401749.6459,E 1317155.6757,EL285.38,--17+50 ROW RT
SP,PN5507,N 2401790.0002,E 1317126.154,EL285.38,--17+50 ROW LT
SP,PN5508,N 2401782.7089,E 1317196.4285,EL284.34,--18+00 ROW RT
SP,PN5509,N 2401819.9143,E 1317163.0256,EL284.34,--18+00 ROW LT
SP,PN5510,N 2401819.6753,E 1317233.6769,EL283.3,--18+50 ROW RT
SP,PN5511,N 2401853.3601,E 1317196.7265,EL283.3,--18+50 ROW LT
SP,PN5512,N 2401860.1756,E 1317267.0488,EL282.26,--19+00 ROW RT
SP,PN5513,N 2401936.3251,E 1317260.8518,EL280.99,--19+57.60 ROW LT
SP,PN5514,N 2401940.997,E 1317326.2424,EL280.05,--20+00 ROW RT
SP,PN5515,N 2401970.5352,E 1317285.9002,EL280.05,--20+00 ROW LT
SP,PN5516,N 2402021.6814,E 1317385.3189,EL277.83,--21+00 ROW RT
SP,PN5517,N 2402051.2196,E 1317344.9767,EL277.83,--21+00 ROW LT
SP,PN5518,N 2402102.3658,E 1317444.3954,EL275.61,--22+00 ROW RT
SP,PN5519,N 2402131.904,E 1317404.0532,EL275.61,--22+00 ROW LT
SP,PN5520,N 2402183.0501,E 1317503.4719,EL274.71,--23+00 ROW RT
SP,PN5521,N 2402212.5884,E 1317463.1297,EL274.71,--23+00 ROW LT
SP,PN5522,N 2402263.7345,E 1317562.5483,EL276.58,--24+00 ROW RT
SP,PN5523,N 2402293.2728,E 1317522.2062,EL276.58,--24+00 ROW LT
SP,PN5524,N 2402344.4189,E 1317621.6248,EL278.17,--25+00 ROW RT
SP,PN5525,N 2402373.9571,E 1317581.2826,EL278.17,--25+00 ROW LT
SP,PN5526,N 2402382.6241,E 1317650.5496,EL277.75,--25+50 ROW RT
SP,PN5527,N 2402415.3909,E 1317612.7827,EL277.75,--25+50 ROW LT
SP,PN5528,N 2402413.4489,E 1317683.2312,EL276.34,--26+00 ROW RT
SP,PN5529,N 2402453.0657,E 1317652.7269,EL276.34,--26+00 ROW LT
SP,PN5530,N 2402437.1665,E 1317721.3853,EL274.07,--26+50 ROW RT
SP,PN5531,N 2402482.0538,E 1317699.3597,EL274.07,--26+50 ROW LT
SP,PN5532,N 2402452.8312,E 1317763.4909,EL271.67,--27+00 ROW RT
SP,PN5533,N 2402501.1996,E 1317750.822,EL271.67,--27+00 ROW LT
SP,PN5534,N 2402459.8186,E 1317807.8692,EL269.26,--27+50 ROW RT
SP,PN5535,N 2402509.7398,E 1317805.0622,EL269.26,--27+50 ROW LT
SP,PN5536,N 2402457.8501,E 1317852.7511,EL266.86,--28+00 ROW RT
SP,PN5537,N 2402507.3338,E 1317859.9178,EL266.86,--28+00 ROW LT
SP,PN5538,N 2402447.0042,E 1317896.3472,EL264.68,--28+50 ROW RT
SP,PN5539,N 2402494.0777,E 1317913.202,EL264.68,--28+50 ROW LT
SP,PN5540,N 2402427.7133,E 1317936.9196,EL263.41,--29+00 ROW RT
SP,PN5541,N 2402470.4999,E 1317962.7905,EL263.41,--29+00 ROW LT
SP,PN5542,N 2402368.8512,E 1318013.5997,EL261.69,--30+00 ROW RT
SP,PN5543,N 2402407.9006,E 1318044.827,EL261.69,--30+00 ROW LT
SP,PN5544,N 2402336.3558,E 1318054.2348,EL260.8,--30+52.03 ROW RT
SP,PN5545,N 2402308.6187,E 1318062.2338,EL259.74,--30+88.17 ROW
SP,PN5546,N 2402258.8027,E 1318071.8703,EL258.91,--31+53.03 ROW
SP,PN5547,N 2402242.9539,E 1318120.293,EL258.6,--31+78.91 ROW
SP,PN5548,N 2402284.4845,E 1318159.1285,EL257.75,--31+46.70 ROW
SP,PN5549,N 2402331.264,E 1318140.6603,EL258.87,--31+05.45 ROW
SP,PN5550,N 2402292.1938,E 1318109.459,EL259.47,--31+28.49 CL CUL-
SP,PN5551,N 2402145.8343,E 1317525.7986,EL279.33,--PAD-18
SP,PN5552,N 2402203.927,E 1317568.3336,EL279.33,--PAD-18
SP,PN5553,N 2402246.6897,E 1317599.6442,EL282.33,--PAD-17
SP,PN5554,N 2402304.7825,E 1317642.1792,EL282.33,--PAD-17
SP,PN5555,N 2402377.361,E 1317702.1464,EL282.33,--PAD-16
SP,PN5556,N 2402411.7998,E 1317765.4719,EL282.33,--PAD-16
SP,PN5557,N 2402059.1749,E 1316384.2387,EL297.7466,--STK5438 CL LOCKL
SP,PN5558,N 2401574.883,E 1316754.6797,EL294.8501,--STK5487 12+50 RO
SP,PN5559,N 2401902.3124,E 1317410.5192,EL260.0,--260 TOE
SP,PN5560,N 2401955.0296,E 1317413.8904,EL260.0,--260 TOE
SP,PN5561,N 2402034.2035,E 1317467.8026,EL260.0,--260 TOE
SP,PN5562,N 2402048.735,E 1317534.0211,EL260.0,--260 TOE
SP,PN5563,N 2401940.5365,E 1317626.4796,EL260.0,--260 TOE
SP,PN5564,N 2401827.8615,E 1317505.8767,EL260.0,--260 TOE
SP,PN5565,N 2401824.161,E 1317460.4091,EL260.0,--260 TOE
SP,PN5566,N 2401797.2986,E 1317456.4195,EL268.0,--268 TOP
SP,PN5567,N 2401802.4149,E 1317519.0852,EL268.0,--268 TOP
SP,PN5568,N 2401852.4964,E 1317566.339,EL268.0,--268 TOP
SP,PN5569,N 2401864.7801,E 1317583.1611,EL268.0,--268 TOP
SP,PN5570,N 2401868.2397,E 1317587.7488,EL265.5,--SPILLWAY
SP,PN5571,N 2401900.5007,E 1317627.2952,EL265.5,--SPILLWAY
SP,PN5572,N 2401905.6829,E 1317632.4677,EL268.0,--268 TOP
SP,PN5573,N 2401926.0986,E 1317651.5529,EL268.0,--268 TOP
SP,PN5574,N 2401946.3096,E 1317649.9048,EL268.0,--268 TOP
SP,PN5575,N 2401983.2399,E 1317631.9405,EL268.0,--268 TOP
SP,PN5576,N 2402042.9165,E 1317575.7459,EL268.0,--268 TOP
SP,PN5577,N 2401760.3108,E 1317467.0831,EL264.0358,--tmppt
SP,PN5578,N 2402097.2942,E 1317782.1745,EL260.0,--260
SP,PN5579,N 2402111.2992,E 1317798.4105,EL260.0,--260
SP,PN5580,N 2402121.9596,E 1317870.3552,EL260.0,--260
SP,PN5581,N 2402115.4985,E 1317888.1184,EL260.0,--260
SP,PN5582,N 2402071.5113,E 1317860.2888,EL254.0,--254
SP,PN5583,N 2402096.0348,E 1317881.1913,EL254.0,--254
SP,PN5584,N 2402107.8655,E 1317878.9585,EL254.0,--254
SP,PN5585,N 2402109.9482,E 1317865.625,EL254.0,--254
SP,PN5586,N 2402101.7463,E 1317808.2558,EL254.0,--254
SP,PN5587,N 2402093.9752,E 1317793.7005,EL254.0,--254
SP,PN5588,N 2402077.9845,E 1317796.5834,EL254.0,--254
SP,PN5589,N 2402070.0439,E 1317831.4359,EL254.0,--254
SP,PN5590,N 2402081.4498,E 1317855.3179,EL254.05,--RISER (TOP)
SP,PN5591,N 2402018.3338,E 1317869.2118,EL249.14,--B9 (INV.)
SP,PN5592,N 2401847.7899,E 1317525.1527,EL257.8,--D1 (INV)
SP,PN5593,N 2401853.765,E 1317533.1713,EL257.8,--10' OFF D1 (INV)
SP,PN5594,N 2401770.9788,E 1317594.8605,EL247.44,--10' OFF D2 (INV)
SP,PN5595,N 2401807.3062,E 1317448.034,EL266.0,--266 grade
SP,PN5596,N 2401894.9359,E 1317393.8052,EL266.0,--266 grade
SP,PN5597,N 2401893.162,E 1317373.1003,EL272.0,--272 grade
SP,PN5598,N 2401964.9991,E 1317398.9048,EL266.0,--266 grade
SP,PN5599,N 2401969.6697,E 1317380.6553,EL272.0,--272 grade
SP,PN5600,N 2402045.2706,E 1317457.1055,EL266.0,--266 grade
SP,PN5601,N 2402060.8093,E 1317446.5293,EL272.0,--272 grade
SP,PN5602,N 2402074.2278,E 1317550.9766,EL270.0,--270 grade
SP,PN5603,N 2402102.1376,E 1317724.8759,EL260.0,--10'^ CL SWALE A
SP,PN5604,N 2402129.2774,E 1317746.8726,EL262.0,--10'^ CL SWALE A
SP,PN5605,N 2402150.1844,E 1317763.8738,EL264.0,--10'^ CL SWALE A
SP,PN5606,N 2402185.8141,E 1317790.1911,EL266.0,--10'^ CL SWALE A
SP,PN5607,N 2402207.7681,E 1317806.1742,EL268.0,--10'^ CL SWALE A
SP,PN5608,N 2402238.3835,E 1317825.2623,EL270.0,--10'^ CL SWALE A
SP,PN5609,N 2402091.2077,E 1317074.7032,EL288.43,--PAD-6 FF
SP,PN5610,N 2402048.6727,E 1317132.796,EL288.43,--PAD-6 FF
SP,PN5611,N 2402014.5902,E 1317179.3445,EL286.83,--PAD-7 FF
SP,PN5612,N 2401972.0552,E 1317237.4372,EL286.83,--PAD-7 FF
SP,PN5613,N 2401876.4802,E 1317147.916,EL288.33,--PAD-20
SP,PN5614,N 2401919.0153,E 1317089.8233,EL288.33,--PAD-20
SP,PN5615,N 2401958.1299,E 1317036.4021,EL293.5,--PAD-21 FF
SP,PN5616,N 2402000.6649,E 1316978.3094,EL293.5,--PAD-21 FF
SP,PN5617,N 2401937.3037,E 1317440.033,EL260.0,--GRADE
SP,PN5618,N 2401975.5237,E 1317472.2702,EL260.0,--GRADE
SP,PN5619,N 2402013.7437,E 1317504.5073,EL260.0,--GRADE
SP,PN5620,N 2401858.4537,E 1317438.9368,EL260.0,--TOE SLOPE
SP,PN5621,N 2401905.0666,E 1317478.253,EL260.0,--GRADE
SP,PN5622,N 2401943.2866,E 1317510.4901,EL260.0,--GRADE
SP,PN5623,N 2401981.5066,E 1317542.7273,EL260.0,--GRADE
SP,PN5624,N 2401872.8295,E 1317516.473,EL260.0,--GRADE
SP,PN5625,N 2401911.0495,E 1317548.7101,EL260.0,--GRADE
SP,PN5626,N 2401949.2695,E 1317580.9473,EL260.0,--GRADE
SP,PN5628,N 2401882.1481,E 1316508.6244,EL301.53,--PAD-24 FF
SP,PN5629,N 2401813.1821,E 1316487.9437,EL301.53,--PAD-24 FF
SP,PN5630,N 2401759.7027,E 1316493.0744,EL304.1,--PAD-25 FF
SP,PN5631,N 2401688.5461,E 1316504.0623,EL304.1,--PAD-25 FF
SP,PN5632,N 2401624.2367,E 1316544.9959,EL301.03,--PAD-26 FF
SP,PN5633,N 2401572.4908,E 1316595.0595,EL301.03,--PAD-26 FF
SP,PN5634,N 2401534.42,E 1316656.7218,EL299.43,--PAD-27 FF
SP,PN5635,N 2401490.7857,E 1316713.9934,EL299.43,--PAD-27 FF
SP,PN5636,N 2401446.412,E 1316781.3114,EL297.13,--PAD-28 FF
SP,PN5637,N 2401442.1227,E 1316853.1835,EL297.13,--PAD-28 FF
SP,PN5638,N 2401471.3884,E 1316898.7191,EL295.18,--PAD-29 FF
SP,PN5639,N 2401504.7872,E 1316962.504,EL295.18,--PAD-29 FF
SP,PN5640,N 2401608.9209,E 1316886.2796,EL298.43,--PAD-19 FF
SP,PN5641,N 2401636.0702,E 1316819.5944,EL298.43,--PAD-19 FF
SP,PN5642,N 2401692.8876,E 1316642.9283,EL301.33,--PAD-23 FF
SP,PN5643,N 2401763.0072,E 1316626.5806,EL301.33,--PAD-23 FF
SP,PN5644,N 2401989.4631,E 1316607.5123,EL299.33,--PAD-1 FF
SP,PN5645,N 2402047.5569,E 1316650.046,EL299.33,--PAD-1 FF
SP,PN5646,N 2402103.9909,E 1316673.4027,EL295.73,--PAD-2 FF
SP,PN5647,N 2402157.5982,E 1316721.4679,EL295.73,--PAD-2 FF
SP,PN5648,N 2402193.7191,E 1316754.3484,EL294.43,--PAD-3 FF
SP,PN5649,N 2402219.163,E 1316821.7027,EL294.43,--PAD-3 FF
SP,PN5650,N 2402231.2359,E 1316869.883,EL292.13,--PAD-4 FF
SP,PN5651,N 2402230.3192,E 1316941.8771,EL292.13,--PAD-4 FF
SP,PN5652,N 2402182.5948,E 1316971.8694,EL290.03,--PAD-5 FF
SP,PN5653,N 2402146.6699,E 1317034.2665,EL290.03,--PAD-5 FF
SP,PN5654,N 2402333.0649,E 1317492.4572,EL282.33,--PAD-8 FF
SP,PN5655,N 2402393.7403,E 1317536.5405,EL282.33,--PAD-8 FF
SP,PN5656,N 2402556.828,E 1317792.9823,EL269.08,--PAD-9 FF
SP,PN5657,N 2402550.6787,E 1317864.7193,EL269.08,--PAD-9 FF
SP,PN5658,N 2402541.5525,E 1317916.869,EL268.83,--PAD-10 FF
SP,PN5659,N 2402508.3779,E 1317980.7708,EL268.83,--PAD-10 FF
SP,PN5660,N 2402465.6844,E 1318040.3593,EL264.33,--PAD-11 FF
SP,PN5661,N 2402420.7171,E 1318096.5905,EL264.33,--PAD-11 FF
SP,PN5662,N 2402361.7491,E 1318168.6078,EL263.33,--PAD-12 FF
SP,PN5663,N 2402310.8483,E 1318219.5303,EL263.33,--PAD-12 FF
SP,PN5664,N 2402164.4177,E 1318164.3238,EL261.33,--PAD-13 FF
SP,PN5665,N 2402196.1354,E 1318099.6865,EL261.33,--PAD-13 FF
SP,PN5666,N 2402216.064,E 1318050.5713,EL266.33,--PAD-14 FF
SP,PN5667,N 2402277.7782,E 1318013.4856,EL266.33,--PAD-14 FF
SP,PN5668,N 2402390.8127,E 1317942.6304,EL273.83,--PAD-15 FF
SP,PN5669,N 2402393.6878,E 1317870.6878,EL273.83,--PAD-15 FF
SP,PN5670,N 2402044.0519,E 1317468.6252,EL260.0,--DW A31
SP,PN5671,N 2402028.9226,E 1317889.0568,EL240.61,--0+50 SAN.INV
SP,PN5672,N 2402019.6063,E 1317839.9324,EL240.86,--1+00 SAN.INV
SP,PN5673,N 2401897.9187,E 1317711.1417,EL242.15,--0+50 SAN.INV
SP,PN5674,N 2401861.9899,E 1317676.3692,EL242.4,--1+00 SAN.INV
SP,PN5675,N 2401826.0612,E 1317641.5968,EL242.65,--1+50 SAN.INV
SP,PN5676,N 2401790.1324,E 1317606.8243,EL242.9,--2+00 SAN.INV
SP,PN5677,N 2401754.2036,E 1317572.0519,EL243.15,--2+50 SAN.INV
SP,PN5678,N 2401693.4909,E 1317490.3123,EL244.72,--0+50 SAN.INV
SP,PN5679,N 2401671.0624,E 1317445.6249,EL245.84,--1+00 SAN.INV
SP,PN5680,N 2401648.634,E 1317400.9374,EL246.96,--1+50 SAN.INV
SP,PN5681,N 2401626.2056,E 1317356.25,EL248.08,--2+00 SAN.INV
SP,PN5682,N 2401579.8629,E 1317298.9346,EL249.25,--0+50 SAN.INV
SP,PN5683,N 2401544.5305,E 1317263.5564,EL249.75,--1+00 SAN.INV
SP,PN5684,N 2401509.198,E 1317228.1782,EL250.25,--1+50 SAN.INV
SP,PN5685,N 2401473.8655,E 1317192.8,EL250.75,--2+00 SAN.INV
SP,PN5686,N 2401501.1596,E 1317114.8344,EL266.04,--0+50 SAN.INV
SP,PN5687,N 2401523.9466,E 1317070.3287,EL270.47,--1+00 SAN.INV
SP,PN5688,N 2401546.7335,E 1317025.8231,EL274.9,--1+50 SAN.INV
SP,PN5689,N 2401569.5204,E 1316981.3174,EL279.32,--2+00 SAN.INV
SP,PN5690,N 2401426.6289,E 1317145.5023,EL251.34,--0+50 SAN.INV
SP,PN5691,N 2402059.2181,E 1317499.9125,EL260.0,--260 TOE
SP,PN5692,N 2401972.5555,E 1317609.0301,EL260.0,--260 TOE
SP,PN5693,N 2401896.8814,E 1317586.6806,EL260.0,--260 TOE
SP,PN5694,N 2401873.4583,E 1317554.0705,EL260.0,--260 TOE
SP,PN5695,N 2401929.3787,E 1317404.6429,EL260.0,--260 TOE
SP,PN5696,N 2401558.8726,E 1316911.9211,EL281.9,--SAN 0+50
SP,PN5697,N 2401544.7123,E 1316885.4922,EL282.05,--29 SAN LAT
SP,PN5698,N 2401518.6022,E 1316899.1638,EL282.05,--29 SAN C/O
SP,PN5699,N 2401535.259,E 1316867.8485,EL282.15,--SAN 1+00
SP,PN5700,N 2401520.6184,E 1316814.6017,EL282.86,--19 SAN LAT
SP,PN5701,N 2401553.5854,E 1316810.2246,EL282.86,--19 SAN C/O
SP,PN5702,N 2401522.6014,E 1316808.1932,EL282.98,--28 SAN LAT
SP,PN5703,N 2401503.6136,E 1316807.06,EL282.98,--28 SAN C/O
SP,PN5704,N 2401530.3139,E 1316783.2678,EL285.87,--SAN 0+50
SP,PN5705,N 2401566.7441,E 1316709.3777,EL287.08,--27 SAN LAT
SP,PN5706,N 2401553.9019,E 1316699.5934,EL287.08,--27 SAN C/O
SP,PN5707,N 2401581.6484,E 1316694.0197,EL287.43,--SAN 0+50
SP,PN5708,N 2401616.4699,E 1316658.1384,EL288.23,--SAN 1+00
SP,PN5709,N 2401651.2913,E 1316622.2571,EL289.04,--SAN 1+50
SP,PN5710,N 2401662.5621,E 1316610.6434,EL289.3,--26 SAN LAT
SP,PN5711,N 2401637.7719,E 1316591.0502,EL289.3,--26 SAN C/O
SP,PN5712,N 2401722.4048,E 1316577.2356,EL290.43,--23-25 SAN LAT
SP,PN5713,N 2401717.0776,E 1316542.7366,EL290.43,--25 SAN C/O
SP,PN5714,N 2401731.7158,E 1316590.5581,EL290.43,--23 SAN C/O
SP,PN5715,N 2401742.3124,E 1316575.4394,EL290.63,--SAN 0+50
SP,PN5716,N 2401802.3475,E 1316570.1924,EL291.23,--24 SAN LAT
SP,PN5717,N 2401819.4862,E 1316544.605,EL291.23,--24 SAN C/O
SP,PN5718,N 2402110.8082,E 1317419.592,EL268.22,--SAN 0+50
SP,PN5719,N 2402070.466,E 1317390.0537,EL268.74,--SAN 1+00
SP,PN5720,N 2402030.1238,E 1317360.5155,EL269.26,--SAN 1+50
SP,PN5721,N 2401989.7817,E 1317330.9772,EL269.78,--SAN 2+00
SP,PN5722,N 2401949.4395,E 1317301.439,EL270.3,--SAN 2+50
SP,PN5723,N 2401909.0973,E 1317271.9007,EL270.82,--SAN 3+00
SP,PN5724,N 2402162.1405,E 1317424.9279,EL267.75,--81 SAN C/O
SP,PN5725,N 2401910.7489,E 1317211.1401,EL271.59,--SAN 0+50
SP,PN5726,N 2401942.8002,E 1317167.3657,EL271.86,--7 SAN LAT
SP,PN5727,N 2401962.9713,E 1317182.1348,EL271.86,--7 SAN C/O
SP,PN5728,N 2401952.0948,E 1317154.6293,EL272.13,--20 SAN LAT
SP,PN5729,N 2401931.9438,E 1317139.8748,EL272.13,--20 SAN C/O
SP,PN5730,N 2401977.3062,E 1317120.2401,EL272.34,--SAN 0+50
SP,PN5731,N 2402006.8451,E 1317079.8984,EL272.59,--SAN 1+00
SP,PN5732,N 2402019.4072,E 1317062.7168,EL272.69,--6 SAN LAT
SP,PN5733,N 2402039.5888,E 1317077.4936,EL272.69,--6 SAN C/O
SP,PN5734,N 2402033.7562,E 1317043.124,EL272.82,--21 SAN LAT
SP,PN5735,N 2402013.5935,E 1317028.3609,EL272.82,--21 SAN C/O
SP,PN5736,N 2402065.9228,E 1316999.2149,EL273.09,--SAN 2+00
SP,PN5737,N 2402096.8474,E 1316956.9735,EL273.35,--5 SAN LAT
SP,PN5738,N 2402117.2422,E 1316971.4375,EL273.35,--5 SAN C/O
SP,PN5739,N 2401851.4165,E 1317208.4284,EL278.6,--INL A8
SP,PN5740,N 2401810.0309,E 1317176.8405,EL279.85,--STM 0+50
SP,PN5741,N 2401770.8036,E 1317145.8369,EL280.89,--STM 1+00
SP,PN5742,N 2401736.7177,E 1317119.3211,EL281.75,--INL A7
SP,PN5743,N 2401720.2916,E 1317069.782,EL283.0,--STM 0+50
SP,PN5744,N 2401703.5171,E 1317020.2279,EL284.05,--INL A6
SP,PN5745,N 2402124.2006,E 1317446.7493,EL270.06,--STM 0+50
SP,PN5746,N 2402172.7475,E 1317483.5344,EL270.8,--INL A27
SP,PN5747,N 2402099.3769,E 1317392.631,EL273.0,--INL A28
SP,PN5748,N 2402040.2969,E 1317385.2986,EL265.91,--STM 0+50
SP,PN5749,N 2401999.9629,E 1317355.7493,EL268.12,--STM 1+00
SP,PN5750,N 2401959.6288,E 1317326.1999,EL270.33,--STM 1+50
SP,PN5751,N 2401919.2948,E 1317296.6506,EL272.54,--STM 2+00
SP,PN5752,N 2401878.9607,E 1317267.1012,EL274.75,--STM 2+50
SP,PN5753,N 2401861.1648,E 1317255.2772,EL275.6,--INL A25
SP,PN5754,N 2401880.0397,E 1317229.4364,EL276.25,--STM 0+30
SP,PN5755,N 2401897.2618,E 1317204.1673,EL276.4,--INL A24
SP,PN5756,N 2401873.9495,E 1317187.1083,EL278.0,--INL A23
SP,PN5757,N 2401921.4679,E 1317221.8913,EL278.7,--INL A22
SP,PN5758,N 2401931.944,E 1317158.4945,EL277.31,--STM 0+50
SP,PN5759,N 2401961.4823,E 1317118.1523,EL278.03,--STM 1+00
SP,PN5760,N 2401991.4591,E 1317075.5184,EL278.75,--INL A21
SP,PN5761,N 2402015.6644,E 1317093.2414,EL280.35,--INL A20
SP,PN5762,N 2402022.9857,E 1317034.1533,EL279.5,--STM 0+50
SP,PN5763,N 2402052.5239,E 1316993.8111,EL280.05,--STM 1+00
SP,PN5764,N 2402082.6817,E 1316950.9301,EL280.6,--INL A19
SP,PN5765,N 2402081.6539,E 1317416.8363,EL269.2,--INL A29 DROP A27
SP,PN5766,N 2401609.1704,E 1316949.9008,EL290.14,--WATER 15+00
SP,PN5767,N 2401648.7466,E 1316980.5459,EL289.39,--WATER 15+50
SP,PN5768,N 2401686.3843,E 1317015.0318,EL288.49,--WATER 16+00
SP,PN5769,N 2401720.3189,E 1317053.1872,EL287.45,--WATER 16+50
SP,PN5770,N 2401749.8646,E 1317094.1096,EL286.41,--WATER 17+00
SP,PN5771,N 2401784.0114,E 1317149.8984,EL285.05,--WATER 17+66
SP,PN5772,N 2401797.0505,E 1317164.192,EL284.64,--30 WATER LAT
SP,PN5773,N 2401773.0281,E 1317185.3367,EL284.64,--30 WATER BOX
SP,PN5774,N 2401810.4124,E 1317178.8395,EL284.24,--30 WATER LAT
SP,PN5775,N 2401786.1479,E 1317200.1973,EL284.24,--30 WATER BOX
SP,PN5776,N 2401833.518,E 1317204.1682,EL283.5,--WATER ANG.
SP,PN5777,N 2401880.7504,E 1317238.7514,EL282.26,--WATER 19+00
SP,PN5778,N 2401895.1867,E 1317249.3216,EL281.87,--WATER TEE
SP,PN5779,N 2401961.4351,E 1317297.8281,EL280.05,--WATER 20+00
SP,PN5780,N 2402002.1329,E 1317327.6268,EL278.94,--WATER 20+50
SP,PN5781,N 2402042.2563,E 1317357.0048,EL277.83,--WATER 21+00
SP,PN5782,N 2402082.7089,E 1317386.6239,EL276.72,--WATER 21+50
SP,PN5783,N 2402123.1514,E 1317416.2356,EL275.61,--WATER 22+00
SP,PN5784,N 2402163.4923,E 1317445.7728,EL274.73,--WATER 22+50
SP,PN5785,N 2402203.3718,E 1317474.9723,EL274.71,--WATER 23+00
SP,PN5786,N 2401918.6146,E 1317217.3246,EL282.17,--WATER 0+50
SP,PN5787,N 2401956.7763,E 1317165.2049,EL282.84,--7 WATER LAT
SP,PN5788,N 2401968.8789,E 1317174.0664,EL282.84,--7 WATER BOX
SP,PN5789,N 2401966.091,E 1317152.4832,EL283.02,--20 WATER LAT
SP,PN5790,N 2401937.8515,E 1317131.8064,EL283.02,--20 WATER BOX
SP,PN5791,N 2402007.2977,E 1317096.2046,EL283.76,--WATER 2+00
SP,PN5792,N 2402033.3938,E 1317060.5637,EL284.22,--6 WATER LAT
SP,PN5793,N 2402045.3093,E 1317069.2882,EL284.22,--6 WATER BOX
SP,PN5794,N 2402047.7406,E 1317040.9693,EL284.48,--21 WATER LAT
SP,PN5795,N 2402019.4397,E 1317020.2476,EL284.48,--21 WATER BOX
SP,PN5796,N 2402066.5855,E 1317015.2317,EL284.81,--WATER 3+00
SP,PN5797,N 2401515.534,E 1316831.0334,EL285.34,--SMH 3.0 (DROP) I
SP,PN5798,N 2401595.5305,E 1316986.6474,EL290.7,--10'^EP LEFT
SP,PN5799,N 2401578.1811,E 1317009.4192,EL288.0,--10'^EP LEFT
SP,PN5800,N 2401545.0818,E 1317052.8633,EL282.0,--10'^EP LEFT
SP,PN5801,N 2401510.6262,E 1317098.0875,EL276.0,--10'^EP LEFT
SP,PN5802,N 2401485.3968,E 1317130.9306,EL272.0,--10'^EP LEFT
SP,PN5803,N 2401450.1957,E 1317158.9085,EL268.0,--10'^EP LEFT
SP,PN5804,N 2401412.212,E 1317171.4988,EL264.0,--10'^EP LEFT
SP,PN5805,N 2402156.5524,E 1317484.0704,EL276.0,--10'^EP LEFT
SP,PN5806,N 2402125.6699,E 1317526.2485,EL274.0,--10'^EP LEFT
SP,PN5807,N 2402094.5211,E 1317568.7903,EL270.0,--10'^EP LEFT
SP,PN5808,N 2402061.829,E 1317613.4399,EL267.0,--10'^EP LEFT
SP,PN5809,N 2402032.2492,E 1317653.839,EL264.0,--10'^EP LEFT
SP,PN5810,N 2402018.6191,E 1317672.4544,EL263.0,--10'^EP L @ PC
SP,PN5811,N 2402016.3353,E 1317682.5212,EL262.0,--10'^EP L @ MID-C
SP,PN5812,N 2402022.1193,E 1317691.0712,EL261.0,--10'^EP L @ PT
SP,PN5813,N 2402050.0337,E 1317712.2385,EL259.2,--10'^EP L @ PC
SP,PN5814,N 2402075.2849,E 1317748.3758,EL258.0,--10'^EP L @ MID
SP,PN5815,N 2402074.7383,E 1317792.4579,EL256.3,--10'^EP L @ PT
SP,PN5816,N 2402059.1211,E 1317839.9731,EL254.0,--10'^EP L @ ANG P
SP,PN5817,N 2402065.9672,E 1317882.3217,EL254.0,--10'^EP L END
SP,PN5818,N 2402079.37,E 1317900.353,EL-99999.0,--PUMP LOT CNR
SP,PN5819,N 2402090.1912,E 1317964.4459,EL-99999.0,--PUMP LOT CNR
SP,PN5820,N 2402035.9587,E 1317973.6024,EL-99999.0,--PUMP LOT CNR
SP,PN5821,N 2402025.1375,E 1317909.5094,EL-99999.0,--PUMP LOT CNR
SP,PN5822,N 2401931.6891,E 1317446.3997,EL262.0,--FENCE  BEG.
SP,PN5823,N 2402011.3552,E 1317509.8383,EL262.0,--FENCE CNR.
SP,PN5824,N 2401913.8677,E 1317639.9176,EL262.0,--FENCE END
SP,PN5825,N 2401848.8628,E 1317423.2708,EL262.0,--FENCE BEG.
SP,PN5826,N 2401975.6635,E 1317525.8405,EL262.0,--FENCE END
SP,PN5827,N 2401859.3785,E 1317491.8232,EL262.0,--FENCE BEG.
SP,PN5828,N 2401962.6388,E 1317574.4101,EL262.0,--FENCE END
SP,PN5829,N 2402284.429,E 1317534.3218,EL276.58,--WATER 24+00
SP,PN5830,N 2402323.0327,E 1317562.5871,EL277.57,--17 WATER LAT
SP,PN5831,N 2402302.3358,E 1317590.8542,EL277.57,--17 WATER BOX
SP,PN5832,N 2402353.0291,E 1317584.5503,EL278.1,--8 WATER LAT
SP,PN5833,N 2402361.846,E 1317572.4149,EL278.1,--8 WATER BOX
SP,PN5834,N 2402365.0435,E 1317593.3471,EL278.17,--WATER 25+00
SP,PN5835,N 2402405.4552,E 1317624.0212,EL277.75,--WATER 25+50
SP,PN5836,N 2402423.2246,E 1317640.9545,EL277.17,--79 WATER LAT
SP,PN5837,N 2402434.7054,E 1317627.8659,EL277.17,--79 WATER BOX
SP,PN5838,N 2402441.234,E 1317661.9474,EL276.34,--WATER 26+00
SP,PN5839,N 2402463.6265,E 1317696.3665,EL274.5,--16 WATER LAT.
SP,PN5840,N 2402432.0644,E 1317711.6016,EL274.5,--16 WATER BOX
SP,PN5841,N 2402486.7155,E 1317754.7234,EL271.67,--WATER 27+00
SP,PN5842,N 2402493.2949,E 1317789.6248,EL269.99,--WATER
SP,PN5843,N 2402490.9853,E 1317819.7519,EL268.64,--9 WATER LAT.
SP,PN5844,N 2402510.172,E 1317821.3966,EL268.64,--9 WATER BOX
SP,PN5845,N 2402484.4279,E 1317904.4568,EL264.89,--WATER
SP,PN5846,N 2402476.2198,E 1317919.3394,EL264.32,--10 WATER LAT.
SP,PN5847,N 2402489.1172,E 1317926.0351,EL264.32,--10 WATER BOX
SP,PN5848,N 2402443.2026,E 1317906.2261,EL264.32,--15 WATER BOX
SP,PN5849,N 2402457.8859,E 1317956.0307,EL263.41,--WATER 29+00
SP,PN5850,N 2402427.4521,E 1317996.3605,EL262.55,--WATER 29+50
SP,PN5851,N 2402400.7341,E 1318029.7712,EL261.81,--11 WATER LAT.
SP,PN5852,N 2402412.4489,E 1318039.1394,EL261.81,--11 WATER BOX
SP,PN5853,N 2402364.8943,E 1318074.5884,EL260.83,--WATER 30+50
SP,PN5854,N 2402346.6022,E 1318097.4626,EL260.31,--14 WATER LAT.
SP,PN5855,N 2402299.7429,E 1318059.9899,EL260.31,--14 WATER BOX
SP,PN5856,N 2402325.1774,E 1318124.2541,EL259.88,--WATER LAT. PUMP
SP,PN5857,N 2402299.4874,E 1318139.2781,EL258.3,--12 WATER LAT.
SP,PN5858,N 2402305.3219,E 1318157.8672,EL258.3,--12 WATER BOX
SP,PN5859,N 2402291.5617,E 1318143.4728,EL258.08,--13 WATER LAT.
SP,PN5860,N 2402251.4723,E 1318139.1597,EL258.08,--13 WATER BOX
SP,PN5861,N 2402286.2641,E 1318151.1735,EL258.08,--FIRE HYD.
SP,PN5862,N 2402250.9455,E 1318081.1999,EL259.0,--WATER BOX PUMP S
SP,PN5863,N 2402153.6812,E 1318024.7871,EL260.0,--WATER LAT. MID-P
SP,PN5864,N 2402056.417,E 1317968.3742,EL252.0,--WATER LAT.
SP,PN5865,N 2402053.6685,E 1317952.0953,EL252.0,--WATER BOX
SP,PN5866,N 2402018.3338,E 1317869.2118,EL249.14,--INL B9
SP,PN5867,N 2402067.1694,E 1317858.4839,EL249.96,--STM 0+50
SP,PN5868,N 2402116.0049,E 1317847.756,EL250.78,--STM 1+00
SP,PN5869,N 2402194.3047,E 1317870.361,EL251.86,--STM 0+50
SP,PN5870,N 2402233.3541,E 1317901.5883,EL252.11,--STM 1+00
SP,PN5871,N 2402272.4035,E 1317932.8156,EL252.36,--STM 1+50
SP,PN5872,N 2402311.4529,E 1317964.0429,EL252.61,--STM 2+00
SP,PN5873,N 2402350.5024,E 1317995.2702,EL252.86,--STM 2+50
SP,PN5874,N 2402417.7967,E 1317986.7704,EL259.08,--STM 0+50
SP,PN5875,N 2402457.149,E 1317955.9257,EL259.82,--STM 1+00
SP,PN5876,N 2402467.6547,E 1317947.6912,EL259.95,--INL B3
SP,PN5877,N 2402341.1709,E 1318064.2252,EL253.8,--INL B6
SP,PN5878,N 2402364.6006,E 1318082.9616,EL257.3,--INL B5
SP,PN5879,N 2402310.5527,E 1318103.754,EL254.25,--STM 0+50
SP,PN5880,N 2402277.3598,E 1318146.6067,EL254.5,--INL B4
SP,PN5881,N 2402378.4444,E 1318017.6151,EL258.33,--INL B7 (DROP)
SP,PN5882,N 2402086.589,E 1317993.0646,EL245.09,--SAN 0+50
SP,PN5883,N 2402129.9789,E 1318017.9105,EL246.4,--SAN 1+00
SP,PN5884,N 2402173.3688,E 1318042.7563,EL247.7,--SAN 1+50
SP,PN5885,N 2402216.7587,E 1318067.6022,EL249.01,--SAN 2+00
SP,PN5886,N 2402260.1486,E 1318092.448,EL250.32,--SAN 2+50
SP,PN5887,N 2402303.5385,E 1318117.2939,EL251.62,--SAN 3+00 LAT. 12
SP,PN5888,N 2402172.743,E 1318056.557,EL247.83,--13 SAN C/O
SP,PN5889,N 2402315.4381,E 1318153.8399,EL251.62,--12 SAN C/O
SP,PN5890,N 2402324.6555,E 1318108.3525,EL252.32,--14 SAN LAT.
SP,PN5891,N 2402271.0638,E 1318063.6341,EL-99999.0,--14 SAN C/O
SP,PN5892,N 2402343.8835,E 1318083.3049,EL252.9,--SAN 0+50
SP,PN5893,N 2402374.3511,E 1318043.6598,EL253.8,--SAN 1+00
SP,PN5894,N 2402397.1048,E 1318014.0646,EL254.47,--11 SAN LAT.
SP,PN5895,N 2402418.6944,E 1318031.3295,EL254.47,--11 SAN C/O
SP,PN5896,N 2402404.8186,E 1318004.0148,EL254.7,--SAN 1+50
SP,PN5897,N 2402435.2861,E 1317964.3697,EL255.6,--SAN 2+00
SP,PN5898,N 2402461.8787,E 1317907.2113,EL256.41,--10-15 SAN LAT.
SP,PN5899,N 2402492.8051,E 1317916.6824,EL256.41,--10 SAN C/O
SP,PN5900,N 2402446.8256,E 1317896.8441,EL256.41,--15 SAN C/O
SP,PN5901,N 2402465.4763,E 1317887.6103,EL256.61,--SAN 0+50
SP,PN5902,N 2402474.4743,E 1317838.4266,EL257.11,--SAN 1+00
SP,PN5903,N 2402479.8513,E 1317808.7608,EL257.41,--9 SAN LAT.
SP,PN5904,N 2402510.0211,E 1317811.3469,EL257.41,--9 SAN C/O
SP,PN5905,N 2402466.0224,E 1317743.1778,EL263.53,--SAN 0+50
SP,PN5906,N 2402447.5353,E 1317693.0296,EL264.92,--16 SAN LAT.
SP,PN5907,N 2402427.0153,E 1317702.9348,EL264.92,--16 SAN C/O
SP,PN5908,N 2402404.1486,E 1317647.3241,EL267.16,--79 SAN LAT.
SP,PN5909,N 2402427.2407,E 1317621.3937,EL267.16,--79 SAN C/O
SP,PN5910,N 2402369.0358,E 1317616.0193,EL268.79,--SAN 1+00
SP,PN5911,N 2402337.9443,E 1317588.2998,EL270.21,--8 SAN LAT.
SP,PN5912,N 2402353.7775,E 1317566.5072,EL270.21,--8 SAN C/O
SP,PN5913,N 2402326.8012,E 1317578.3652,EL270.73,--17 SAN LAT.
SP,PN5914,N 2402310.4244,E 1317596.7343,EL270.73,--17 SAN C/O
SP,PN5915,N 2402483.3171,E 1317790.0915,EL262.22,--SMH 15.0 (DROP)
SP,PN5916,N 2402124.1659,E 1316910.0603,EL273.82,--4 SAN LAT.
SP,PN5917,N 2402147.8298,E 1316905.6266,EL273.82,--4 SAN C/O
SP,PN5918,N 2402120.9231,E 1316891.3096,EL273.92,--22 SAN LAT.
SP,PN5919,N 2402099.0262,E 1316895.0797,EL273.92,--22 SAN C/O
SP,PN5920,N 2402101.9484,E 1316876.1977,EL274.01,--22 SAN C/O
SP,PN5921,N 2402117.5302,E 1316871.7139,EL274.01,--22 SAN LAT.
SP,PN5922,N 2402110.1398,E 1316829.0319,EL274.23,--3 SAN LAT.
SP,PN5923,N 2402142.587,E 1316808.6688,EL274.23,--3 SAN C/O
SP,PN5924,N 2402141.5278,E 1316742.3768,EL274.96,--SAN 0+50
SP,PN5925,N 2402183.1135,E 1316714.6166,EL275.21,--SAN 1+00
SP,PN5926,N 2402224.6992,E 1316686.8564,EL275.46,--SAN 1+50
SP,PN5927,N 2402266.2849,E 1316659.0962,EL275.71,--SAN 2+00
SP,PN5928,N 2402099.9421,E 1316770.137,EL281.59,--SMH 7.0 (DROP)
SP,PN5929,N 2402033.3327,E 1317969.848,EL243.59,--10'^SMH 18.0
SP,PN5930,N 2402028.3995,E 1317970.6627,EL243.59,--15'^SMH 18.0
SP,PN5931,N 2402028.4512,E 1317940.2622,EL240.16,--10'^SMH 19.0
SP,PN5932,N 2402023.5403,E 1317941.2019,EL240.16,--15'^SMH 19.0
SP,PN5933,N 2402038.7475,E 1317887.1935,EL240.61,--10'^SAN. 0+50
SP,PN5934,N 2402029.4312,E 1317838.0691,EL240.86,--10'^SAN. 1+00
SP,PN5935,N 2402022.5173,E 1317801.6122,EL241.03,--10'^SMH 20.0
SP,PN5936,N 2402027.4297,E 1317800.6806,EL241.03,--15'^SMH 20.0
SP,PN5937,N 2401978.2056,E 1317765.9167,EL241.48,--10'^SAN. 0+50
SP,PN5938,N 2401939.7439,E 1317737.8375,EL241.7,--10'^SMH 20.1
SP,PN5939,N 2401942.6921,E 1317733.7991,EL241.7,--15'^SMH 20.1
SP,PN5940,N 2401904.8732,E 1317703.9559,EL242.15,--10'^SAN. 0+50
SP,PN5941,N 2401868.9444,E 1317669.1835,EL242.4,--10'^SAN. 1+00
SP,PN5942,N 2401833.0157,E 1317634.411,EL242.65,--10'^SAN 1+50
SP,PN5943,N 2401797.0869,E 1317599.6386,EL242.9,--10'^SAN 2+00
SP,PN5944,N 2401761.1581,E 1317564.8661,EL243.15,--10'^SAN 2+50
SP,PN5945,N 2401722.8738,E 1317527.8139,EL243.4,--10'^SMH 12.0
SP,PN5946,N 2401726.351,E 1317524.2211,EL243.4,--15'^SMH 12.0
SP,PN5947,N 2401702.4284,E 1317485.8266,EL244.72,--10'^SAN 0+50
SP,PN5948,N 2401679.9999,E 1317441.1392,EL245.84,--10'^SAN 1+00
SP,PN5949,N 2401657.5715,E 1317396.4517,EL246.96,--10'^SAN 1+50
SP,PN5950,N 2401635.1431,E 1317351.7643,EL248.08,--10'^SAN 2+00
SP,PN5951,N 2401624.1329,E 1317329.8271,EL248.55,--10'^SMH 5.2
SP,PN5952,N 2401628.6016,E 1317327.5843,EL248.55,--15'^SMH 5.2
SP,PN5953,N 2401616.0978,E 1317321.1059,EL248.84,--SAN. C/O @ ROW
SP,PN5954,N 2401586.9386,E 1317291.8681,EL249.25,--10'^SAN 0+50
SP,PN5955,N 2401581.9557,E 1317286.9286,EL249.32,--SAN. C/O @ ROW
SP,PN5956,N 2401551.6061,E 1317256.4899,EL249.75,--10'^SAN 1+00
SP,PN5957,N 2401516.2391,E 1317221.1444,EL250.25,--10'^SAN 1+50
SP,PN5958,N 2401480.9019,E 1317185.7708,EL250.75,--10'^SAN 2+00
SP,PN5959,N 2401469.037,E 1317173.814,EL250.88,--10'^SMH 5.0
SP,PN5960,N 2401472.5749,E 1317170.2808,EL250.88,--15'^SMH 5.0
SP,PN5961,N 2401619.6352,E 1317317.5722,EL248.84,--
SP,PN5962,N 2401706.8971,E 1317483.5838,EL244.72,--15' O.S.SAN
SP,PN5963,N 2401938.9003,E 1317335.1783,EL277.0758,--TB
SP,PN5964,N 2401910.952,E 1317340.3297,EL276.8783,--TB
SP,PN5965,N 2401887.3914,E 1317358.119,EL276.0763,--TB
SP,PN5966,N 2401867.5387,E 1317376.3865,EL275.8335,--TB
SP,PN5967,N 2401842.0773,E 1317395.6633,EL274.56,--TB
SP,PN5968,N 2401819.8703,E 1317419.0686,EL272.1734,--TB
SP,PN5969,N 2401806.24,E 1317439.4484,EL269.9524,--TB
SP,PN5970,N 2401797.1976,E 1317455.9651,EL268.8981,--TB
SP,PN5971,N 2401788.1707,E 1317452.7277,EL268.3082,--TB
SP,PN5972,N 2401796.1122,E 1317483.5891,EL268.8312,--TB
SP,PN5973,N 2401785.7024,E 1317485.9967,EL268.5158,--TB
SP,PN5974,N 2401791.5255,E 1317519.1265,EL267.9319,--TB
SP,PN5975,N 2401802.9462,E 1317518.9871,EL268.5374,--TB
SP,PN5976,N 2401823.0693,E 1317540.0859,EL267.8487,--TB
SP,PN5977,N 2401816.242,E 1317546.9457,EL267.708,--TB
SP,PN5978,N 2401839.8,E 1317569.7103,EL267.887,--TB
SP,PN5979,N 2401847.202,E 1317563.2627,EL267.5725,--TB
SP,PN5980,N 2401865.4026,E 1317582.9343,EL267.305,--TB
SP,PN5981,N 2401865.3902,E 1317582.8694,EL267.3047,--SPILLWAY
SP,PN5982,N 2401857.6197,E 1317590.5357,EL267.4576,--SPILLWAY
SP,PN5983,N 2401857.669,E 1317590.5302,EL267.4577,--TB
SP,PN5984,N 2401864.2257,E 1317603.1035,EL265.207,--SPILLWAY
SP,PN5985,N 2401875.3511,E 1317593.6937,EL265.5352,--SPILLWAY
SP,PN5986,N 2401899.7885,E 1317625.4287,EL265.6871,--SPILLWAY
SP,PN5987,N 2401888.7964,E 1317634.1764,EL265.2845,--SPILLWAY
SP,PN5988,N 2401897.6902,E 1317641.4046,EL266.9583,--SPILLWAY
SP,PN5989,N 2401897.6662,E 1317641.4282,EL266.9457,--TB
SP,PN5990,N 2401905.5183,E 1317632.7256,EL267.3426,--TB
SP,PN5991,N 2401905.4662,E 1317632.6842,EL267.3367,--SPILLWAY
SP,PN5992,N 2401926.2342,E 1317651.1217,EL267.921,--TB
SP,PN5993,N 2401922.1676,E 1317661.025,EL267.8517,--TB
SP,PN5994,N 2401952.284,E 1317660.2016,EL267.8096,--TB
SP,PN5995,N 2401949.7751,E 1317648.2406,EL267.568,--TB
SP,PN5996,N 2401982.3651,E 1317632.0478,EL267.4981,--TB
SP,PN5997,N 2401989.6079,E 1317641.436,EL267.8322,--TB
SP,PN5998,N 2402015.2391,E 1317617.554,EL267.422,--TB
SP,PN5999,N 2402007.6214,E 1317609.1944,EL267.3763,--TB
SP,PN6000,N 2402042.5657,E 1317575.9185,EL267.574,--TB
SP,PN6001,N 2402048.3067,E 1317583.5044,EL267.6694,--TB
SP,PN6002,N 2402074.0732,E 1317551.0347,EL269.4894,--TB
SP,PN6003,N 2402089.0375,E 1317521.9715,EL268.6052,--TB
SP,PN6004,N 2402095.0721,E 1317490.6402,EL268.4251,--TB
SP,PN6005,N 2402076.4442,E 1317461.6022,EL269.1439,--TB
SP,PN6006,N 2402060.8371,E 1317446.851,EL270.6743,--TB
SP,PN6007,N 2402034.6481,E 1317421.7989,EL271.031,--TB
SP,PN6008,N 2402007.5971,E 1317397.4002,EL272.2934,--TB
SP,PN6009,N 2401971.7199,E 1317371.2833,EL272.9565,--TB
SP,PN6010,N 2401967.4397,E 1317421.53,EL257.721,--BB
SP,PN6011,N 2401934.8986,E 1317411.3591,EL258.3464,--BB
SP,PN6012,N 2401905.8013,E 1317412.5283,EL258.1311,--BB
SP,PN6013,N 2401873.5456,E 1317431.3079,EL258.2924,--BB
SP,PN6014,N 2401828.5966,E 1317461.6058,EL258.609,--BB
SP,PN6015,N 2401825.7117,E 1317492.1851,EL258.6963,--BB
SP,PN6016,N 2401837.0481,E 1317520.3684,EL258.0419,--BB
SP,PN6017,N 2401844.8548,E 1317526.9934,EL260.1286,--TOP_RISER_PIPE
SP,PN6018,N 2401873.6124,E 1317552.4598,EL257.9147,--BB
SP,PN6019,N 2401893.5645,E 1317579.2891,EL258.3723,--BB
SP,PN6020,N 2401912.3886,E 1317605.2698,EL259.0579,--BB
SP,PN6021,N 2401927.4965,E 1317620.3221,EL258.8569,--BB
SP,PN6022,N 2401941.3394,E 1317625.0489,EL258.8312,--BB
SP,PN6023,N 2401968.9296,E 1317611.7695,EL259.2323,--BB
SP,PN6024,N 2401996.7133,E 1317585.271,EL258.7047,--BB
SP,PN6025,N 2402024.4889,E 1317556.2426,EL258.8141,--BB
SP,PN6026,N 2402048.2797,E 1317532.1016,EL258.4029,--BB
SP,PN6027,N 2402062.172,E 1317510.0578,EL259.197,--BB
SP,PN6028,N 2402044.3479,E 1317486.4145,EL258.8132,--BB
SP,PN6029,N 2402011.1149,E 1317450.9536,EL258.5501,--BB
SP,PN6030,N 2402002.2241,E 1317489.2367,EL258.5741,--G
SP,PN6031,N 2401969.6451,E 1317523.8469,EL258.4055,--G
SP,PN6032,N 2401930.4514,E 1317556.4337,EL258.2976,--G
SP,PN6033,N 2401881.6962,E 1317510.9549,EL258.0036,--G
SP,PN6034,N 2401903.5157,E 1317486.1984,EL258.0291,--G
SP,PN6035,N 2401948.6987,E 1317459.4422,EL258.2682,--G
SP,PN6036,N 2402044.0519,E 1317468.6252,EL260.0,--HW A31
SP,PN6037,N 2402056.1899,E 1317477.4382,EL260.0,--15'^HW A31
SP,PN6038,N 2402031.9139,E 1317459.8123,EL260.0,--15'^HW A31
SP,PN6039,N 2402081.6539,E 1317416.8363,EL263.5,--InlA29@f/c
SP,PN6040,N 2402093.7919,E 1317425.6493,EL263.5,--15'^InlA29@f/c
SP,PN6041,N 2402069.5159,E 1317408.0234,EL263.5,--15'^InlA29@f/c
SP,PN6042,N 2401835.3575,E 1317534.4367,EL256.29,--ASC-cut to pipe
SP,PN6043,N 2401844.3181,E 1317546.4662,EL256.29,--15'^ASC
SP,PN6044,N 2401826.397,E 1317522.4072,EL256.29,--15'^ASC
SP,PN6045,N 2401814.9074,E 1317549.6696,EL253.75,--ASC-cut to pipe
SP,PN6046,N 2401823.8679,E 1317561.6991,EL253.75,--15'^ASC
SP,PN6047,N 2401805.9468,E 1317537.6401,EL253.75,--15'^ASC
SP,PN6048,N 2401794.4572,E 1317564.9025,EL251.21,--ASC-cut to pipe
SP,PN6049,N 2401803.4178,E 1317576.932,EL251.21,--15'^ASC
SP,PN6050,N 2401785.4967,E 1317552.873,EL251.21,--15'^ASC
SP,PN6051,N 2401867.1693,E 1317581.0186,EL265.5,--spillway
SP,PN6052,N 2401885.9374,E 1317605.5929,EL265.5,--spillway
SP,PN6053,N 2401907.7248,E 1317629.9205,EL265.5,--spillway
SP,PN6054,N 2401897.5474,E 1317643.8576,EL265.5,--spillway
SP,PN6055,N 2401871.0798,E 1317615.0588,EL265.5,--spillway
SP,PN6056,N 2401854.5639,E 1317592.2422,EL265.5,--spillway
SP,PN6057,N 2401891.0447,E 1317069.3434,EL288.33,--blast20
SP,PN6058,N 2401878.6387,E 1317086.2872,EL288.33,--blast20
SP,PN6059,N 2401891.5482,E 1317095.7394,EL288.33,--blast20
SP,PN6060,N 2401883.9667,E 1317106.0939,EL288.33,--blast20
SP,PN6061,N 2401885.0425,E 1317106.8816,EL288.33,--blast20
SP,PN6062,N 2401876.9687,E 1317117.9084,EL288.33,--blast20
SP,PN6063,N 2401873.4724,E 1317115.3485,EL288.33,--blast20
SP,PN6064,N 2401864.9063,E 1317127.0477,EL288.33,--blast20
SP,PN6065,N 2401836.8012,E 1317106.4694,EL288.33,--blast20
SP,PN6066,N 2401846.3273,E 1317093.459,EL288.33,--blast20
SP,PN6067,N 2401837.7882,E 1317087.2068,EL288.33,--blast20
SP,PN6068,N 2401849.3081,E 1317071.4733,EL288.33,--blast20
SP,PN6069,N 2401854.6198,E 1317075.3625,EL288.33,--blast20
SP,PN6070,N 2401861.3152,E 1317066.2183,EL288.33,--blast20
SP,PN6071,N 2401864.5425,E 1317068.5813,EL288.33,--blast20
SP,PN6072,N 2401873.4286,E 1317056.4451,EL288.33,--blast20
SP,PN6073,N 2401970.8634,E 1316956.489,EL293.5,--blast21
SP,PN6074,N 2401957.2567,E 1316973.3798,EL293.5,--blast21
SP,PN6075,N 2401970.2677,E 1316982.9064,EL293.5,--blast21
SP,PN6076,N 2401966.6739,E 1316987.8147,EL293.5,--blast21
SP,PN6077,N 2401968.4557,E 1316989.1193,EL293.5,--blast21
SP,PN6078,N 2401950.5358,E 1317013.5936,EL293.5,--blast21
SP,PN6079,N 2401956.9227,E 1317018.27,EL293.5,--blast21
SP,PN6080,N 2401946.9289,E 1317031.9191,EL293.5,--blast21
SP,PN6081,N 2401912.3355,E 1317006.59,EL293.5,--blast21
SP,PN6082,N 2401921.8123,E 1316993.6469,EL293.5,--blast21
SP,PN6083,N 2401919.5263,E 1316991.9731,EL293.5,--blast21
SP,PN6084,N 2401932.8185,E 1316973.8191,EL293.5,--blast21
SP,PN6085,N 2401925.9603,E 1316968.7976,EL293.5,--blast21
SP,PN6086,N 2401933.271,E 1316958.8129,EL293.5,--blast21
SP,PN6087,N 2401927.5727,E 1316954.6406,EL293.5,--blast21
SP,PN6088,N 2401938.8464,E 1316939.2434,EL293.5,--blast21
SP,PN6089,N 2401957.6728,E 1316953.0279,EL293.5,--blast21
SP,PN6090,N 2401960.6266,E 1316948.9936,EL293.5,--blast21
SP,PN6091,N 2402117.8168,E 1317094.1862,EL288.43,--blast6
SP,PN6092,N 2402128.0536,E 1317101.6815,EL288.43,--blast6
SP,PN6093,N 2402125.0998,E 1317105.7157,EL288.43,--blast6
SP,PN6094,N 2402143.9261,E 1317119.5002,EL288.43,--blast6
SP,PN6095,N 2402132.6524,E 1317134.8975,EL288.43,--blast6
SP,PN6096,N 2402126.954,E 1317130.7252,EL288.43,--blast6
SP,PN6097,N 2402119.6433,E 1317140.7099,EL288.43,--blast6
SP,PN6098,N 2402112.7851,E 1317135.6884,EL288.43,--blast6
SP,PN6099,N 2402099.4929,E 1317153.8424,EL288.43,--blast6
SP,PN6100,N 2402097.2069,E 1317152.1686,EL288.43,--blast6
SP,PN6101,N 2402087.73,E 1317165.1117,EL288.43,--blast6
SP,PN6102,N 2402053.1366,E 1317139.7826,EL288.43,--blast6
SP,PN6103,N 2402063.1304,E 1317126.1335,EL288.43,--blast6
SP,PN6104,N 2402069.5172,E 1317130.8099,EL288.43,--blast6
SP,PN6105,N 2402087.4371,E 1317106.3357,EL288.43,--blast6
SP,PN6106,N 2402089.2189,E 1317107.6403,EL288.43,--blast6
SP,PN6107,N 2402092.8127,E 1317102.732,EL288.43,--blast6
SP,PN6108,N 2402105.8237,E 1317112.2585,EL288.43,--blast6
SP,PN6109,N 2402040.1403,E 1317198.052,EL286.83,--blast7
SP,PN6110,N 2402057.7564,E 1317210.9504,EL286.83,--blast7
SP,PN6111,N 2402048.8703,E 1317223.0866,EL286.83,--blast7
SP,PN6112,N 2402052.0977,E 1317225.4497,EL286.83,--blast7
SP,PN6113,N 2402045.4023,E 1317234.5939,EL286.83,--blast7
SP,PN6114,N 2402050.7141,E 1317238.4831,EL286.83,--blast7
SP,PN6115,N 2402039.1941,E 1317254.2166,EL286.83,--blast7
SP,PN6116,N 2402030.655,E 1317247.9643,EL286.83,--blast7
SP,PN6117,N 2402021.129,E 1317260.9747,EL286.83,--blast7
SP,PN6118,N 2401993.0239,E 1317240.3964,EL286.83,--blast7
SP,PN6119,N 2402001.59,E 1317228.6971,EL286.83,--blast7
SP,PN6120,N 2401998.0937,E 1317226.1372,EL286.83,--blast7
SP,PN6121,N 2402006.1675,E 1317215.1103,EL286.83,--blast7
SP,PN6122,N 2402007.2432,E 1317215.898,EL286.83,--blast7
SP,PN6123,N 2402014.8247,E 1317205.5435,EL286.83,--blast7
SP,PN6124,N 2402027.7342,E 1317214.9957,EL286.83,--blast7
SP,PN6125,N 2402382.594,E 1317488.9138,EL286.83,--blast7
SP,PN6126,N 2402390.0516,E 1317478.6494,EL286.83,--blast7
SP,PN6127,N 2402394.0967,E 1317481.5883,EL286.83,--blast7
SP,PN6128,N 2402407.8116,E 1317462.7113,EL286.83,--blast7
SP,PN6129,N 2402423.2504,E 1317473.9282,EL286.83,--blast7
SP,PN6130,N 2402419.0991,E 1317479.6419,EL286.83,--blast7
SP,PN6131,N 2402429.1107,E 1317486.9157,EL286.83,--blast7
SP,PN6132,N 2402424.1146,E 1317493.7923,EL286.83,--blast7
SP,PN6133,N 2402442.3174,E 1317507.0175,EL286.83,--blast7
SP,PN6134,N 2402440.6521,E 1317509.3097,EL286.83,--blast7
SP,PN6135,N 2402453.63,E 1317518.7388,EL286.83,--blast7
SP,PN6136,N 2402428.4287,E 1317553.4254,EL286.83,--blast7
SP,PN6137,N 2402414.7429,E 1317543.482,EL286.83,--blast7
SP,PN6138,N 2402419.3957,E 1317537.078,EL286.83,--blast7
SP,PN6139,N 2402394.8555,E 1317519.2485,EL286.83,--blast7
SP,PN6140,N 2402396.1535,E 1317517.4619,EL286.83,--blast7
SP,PN6141,N 2402391.232,E 1317513.8862,EL286.83,--blast7
SP,PN6142,N 2402400.7105,E 1317500.8401,EL286.83,--blast7
SP,PN6143,N 2402266.2951,E 1317983.077,EL266.33,--blast14
SP,PN6144,N 2402247.2086,E 1317993.3799,EL266.33,--blast14
SP,PN6145,N 2402255.5147,E 1318007.2021,EL266.33,--blast14
SP,PN6146,N 2402250.3004,E 1318010.3355,EL266.33,--blast14
SP,PN6147,N 2402251.4379,E 1318012.2283,EL266.33,--blast14
SP,PN6148,N 2402225.4379,E 1318027.8524,EL266.33,--blast14
SP,PN6149,N 2402229.5152,E 1318034.6374,EL266.33,--blast14
SP,PN6150,N 2402215.0152,E 1318043.3509,EL266.33,--blast14
SP,PN6151,N 2402192.9311,E 1318006.6009,EL266.33,--blast14
SP,PN6152,N 2402206.6811,E 1317998.3382,EL266.33,--blast14
SP,PN6153,N 2402205.2217,E 1317995.9096,EL266.33,--blast14
SP,PN6154,N 2402224.5074,E 1317984.3203,EL266.33,--blast14
SP,PN6155,N 2402220.1292,E 1317977.0346,EL266.33,--blast14
SP,PN6156,N 2402230.7364,E 1317970.6605,EL266.33,--blast14
SP,PN6157,N 2402227.0986,E 1317964.6069,EL266.33,--blast14
SP,PN6158,N 2402243.4557,E 1317954.7775,EL266.33,--blast14
SP,PN6159,N 2402255.4743,E 1317974.7774,EL266.33,--blast14
SP,PN6160,N 2402259.76,E 1317972.202,EL266.33,--blast14
SP,PN6161,N 2401847.7899,E 1317525.1527,EL257.8,--D1-cut to inv. o
SP,PN6162,N 2401856.9738,E 1317537.0126,EL257.8,--15'^D1-cut to in
SP,PN6163,N 2401838.606,E 1317513.2929,EL257.8,--15'^D1-cut to in
SP,PN6164,N 2401759.5849,E 1317590.8783,EL246.72,--D2 CL-cut to inv
SP,PN6165,N 2401768.5475,E 1317602.9062,EL246.72,--15'^D2-cut to in
SP,PN6166,N 2401750.6223,E 1317578.8503,EL246.72,--15'^D2-cut to in
SP,PN6167,N 2401455.9011,E 1317188.835,EL259.41,--10'^SMH 5.0
SP,PN6168,N 2401452.871,E 1317192.8122,EL259.41,--15'^SMH 5.0-cut
SP,PN6169,N 2401478.3727,E 1317159.3401,EL261.42,--SMH 4.1-cut to i
SP,PN6170,N 2401487.2738,E 1317163.8975,EL261.42,--10'^SMH 4.1-cut
SP,PN6171,N 2401491.7244,E 1317166.1762,EL261.42,--15'^SMH 4.1- cut
SP,PN6172,N 2401510.0607,E 1317119.3918,EL266.04,--10'^SAN 0+50
SP,PN6173,N 2401532.8477,E 1317074.8861,EL270.47,--10'^SAN 1+00
SP,PN6174,N 2401555.6346,E 1317030.3804,EL274.9,--10'^SAN 1+50
SP,PN6175,N 2401578.4216,E 1316985.8748,EL279.32,--10'^SAN 2+00
SP,PN6176,N 2401582.4861,E 1316955.9938,EL281.45,--SMH 4.0-cut to i
SP,PN6177,N 2401591.3873,E 1316960.5512,EL281.45,--10'^SMH 4.0-cut
SP,PN6178,N 2401595.8378,E 1316962.8299,EL281.45,--15'^SMH 4.0-cut
SP,PN6179,N 2401573.585,E 1316951.4364,EL281.45,--10'^SMH 4.0
SP,PN6180,N 2401569.1344,E 1316949.1577,EL281.45,--15'^SMH 4.0
SP,PN6181,N 2401567.6871,E 1316907.1984,EL281.9,--10'^SAN 0+50
SP,PN6182,N 2401544.0736,E 1316863.1257,EL282.15,--10'^san 1+00
SP,PN6183,N 2401515.534,E 1316831.0334,EL282.34,--SMH 3.0-cut to i
SP,PN6184,N 2401524.3486,E 1316826.3107,EL282.34,--10'^SMH 3.0-cut
SP,PN6185,N 2401528.7558,E 1316823.9494,EL282.34,--15'^SMH 3.0-cut
SP,PN6186,N 2401506.7195,E 1316835.7561,EL282.34,--10'^SMH 3.0-cut
SP,PN6187,N 2401502.3122,E 1316838.1175,EL282.34,--15'^SMH 3.0-cut
SP,PN6188,N 2401539.8671,E 1316786.2238,EL283.46,--10'^SAN 0+50
SP,PN6189,N 2401546.827,E 1316729.901,EL284.42,--SMH 3.1-inv out
SP,PN6190,N 2401556.3801,E 1316732.857,EL284.42,--10'^SMH 3.1-inv
SP,PN6191,N 2401561.1567,E 1316734.335,EL284.42,--15'^SMH 3.1-inv
SP,PN6192,N 2401845.114,E 1317546.1965,EL257.8,--15'X15'D1
SP,PN6193,N 2401826.7462,E 1317522.4768,EL257.8,--15'X15'D1
SP,PN6194,N 2401747.6348,E 1317574.841,EL246.72,--20'OSD2
SP,PN6195,N 2401771.535,E 1317606.9155,EL246.72,--20'OSD2
SP,PN6196,N 2401469.4716,E 1317154.7827,EL261.42,--10_OS_MH4.1
SP,PN6197,N 2401537.2739,E 1316726.945,EL284.42,--10_OS_MH3.1
SP,PN6198,N 2401532.4973,E 1316725.467,EL284.42,--15_OS_MN3.1
SP,PN6199,N 2402362.2393,E 1317864.8859,EL273.83,--BLAST15
SP,PN6200,N 2402357.325,E 1317886.0116,EL273.83,--BLAST15
SP,PN6201,N 2402373.1832,E 1317888.9373,EL273.83,--BLAST15
SP,PN6202,N 2402372.0795,E 1317894.9197,EL273.83,--BLAST15
SP,PN6203,N 2402374.2512,E 1317895.3203,EL273.83,--BLAST15
SP,PN6204,N 2402368.7479,E 1317925.1502,EL273.83,--BLAST15
SP,PN6205,N 2402376.5324,E 1317926.5864,EL273.83,--BLAST15
SP,PN6206,N 2402373.4632,E 1317943.2223,EL273.83,--BLAST15
SP,PN6207,N 2402331.2998,E 1317935.4436,EL273.83,--BLAST15
SP,PN6208,N 2402334.2102,E 1317919.6682,EL273.83,--BLAST15
SP,PN6209,N 2402331.4239,E 1317919.1541,EL273.83,--BLAST15
SP,PN6210,N 2402335.506,E 1317897.0275,EL273.83,--BLAST15
SP,PN6211,N 2402327.147,E 1317895.4854,EL273.83,--BLAST15
SP,PN6212,N 2402329.3922,E 1317883.3158,EL273.83,--BLAST15
SP,PN6213,N 2402322.4469,E 1317882.0344,EL273.83,--BLAST15
SP,PN6214,N 2402325.9092,E 1317863.2678,EL273.83,--BLAST15
SP,PN6215,N 2402348.8553,E 1317867.5011,EL273.83,--BLAST15
SP,PN6216,N 2402349.7624,E 1317862.5841,EL273.83,--BLAST15
SP,PN6217,N 2401588.8247,E 1316700.984,EL285.43,--10'^San
SP,PN6218,N 2401623.6461,E 1316665.1027,EL286.23,--10'^San
SP,PN6219,N 2401658.4676,E 1316629.2214,EL287.04,--10'^San
SP,PN6220,N 2401692.5022,E 1316579.7919,EL287.93,--SMH2.0
SP,PN6221,N 2401693.3727,E 1316589.754,EL287.93,--10'^SMH2.0
SP,PN6222,N 2401691.6317,E 1316569.8299,EL287.93,--10'^SMH2.0
SP,PN6223,N 2401693.808,E 1316594.735,EL287.93,--15'^SMH2.0
SP,PN6224,N 2401691.1965,E 1316564.8489,EL287.93,--15'^SMH2.0
SP,PN6225,N 2401743.1829,E 1316585.4014,EL288.63,--10'^San
SP,PN6226,N 2401792.9931,E 1316581.0489,EL289.13,--10'^San
SP,PN6227,N 2401814.1009,E 1316569.1664,EL289.31,--SMH1.0
SP,PN6228,N 2401814.9714,E 1316579.1284,EL289.31,--10'^SMH1.0
SP,PN6229,N 2401813.2304,E 1316559.2043,EL289.31,--10'^SMH1.0
SP,PN6230,N 2401815.4066,E 1316584.1094,EL289.31,--15'^SMH1.0
SP,PN6231,N 2401812.7951,E 1316554.2233,EL289.31,--15'^SMH1.0
SP,PN6232,N 2401802.3475,E 1316570.1924,EL0.0,--Lat24
SP,PN6233,N 2401819.4862,E 1316544.605,EL0.0,--Lat24
SP,PN6234,N 2401724.0168,E 1316577.0305,EL0.0,--Lat23
SP,PN6235,N 2401731.7158,E 1316590.5581,EL0.0,--Lat23
SP,PN6236,N 2401722.4048,E 1316577.2356,EL0.0,--Lat25
SP,PN6237,N 2401717.0776,E 1316542.7366,EL0.0,--Lat25
SP,PN6238,N 2401662.5621,E 1316610.6434,EL0.0,--Lat27
SP,PN6239,N 2401637.7719,E 1316591.0502,EL0.0,--Lat27
SP,PN6240,N 2401566.7441,E 1316709.3777,EL0.0,--Lat27
SP,PN6241,N 2401553.9019,E 1316699.5934,EL0.0,--Lat27
SP,PN6242,N 2401971.4542,E 1317711.4796,EL248.87,--10'^8"San
SP,PN6243,N 2402000.9924,E 1317671.1374,EL251.83,--10'^8"San
SP,PN6244,N 2402030.5307,E 1317630.7952,EL254.8,--10'^8"San
SP,PN6245,N 2402060.0689,E 1317590.453,EL257.76,--10'^8"San
SP,PN6246,N 2402089.6071,E 1317550.1108,EL260.73,--10'^8"San
SP,PN6247,N 2402119.1454,E 1317509.7686,EL263.69,--10'^8"San
SP,PN6248,N 2402148.6836,E 1317469.4265,EL266.66,--10'^8"San
SP,PN6249,N 2402007.6183,E 1317662.088,EL252.5,--10'^8" San @ FM
SP,PN6250,N 2402153.3221,E 1317463.0914,EL267.12,--10'^8" San @ FM
SP,PN6251,N 2402157.0581,E 1317441.0618,EL267.5,--10'^SMH 11.0
SP,PN6252,N 2402160.0119,E 1317437.0275,EL267.5,--15'^SMH 11.0
SP,PN6253,N 2402149.0045,E 1317435.165,EL267.8,--10'^8"San@FM
SP,PN6254,N 2402116.7159,E 1317411.5235,EL268.22,--10'^8"San
SP,PN6255,N 2402076.3737,E 1317381.9853,EL268.74,--10'^8"San
SP,PN6256,N 2402036.0315,E 1317352.447,EL269.26,--10'^8"San
SP,PN6257,N 2401995.6893,E 1317322.9088,EL269.78,--10'^8"San
SP,PN6258,N 2401955.3471,E 1317293.3705,EL270.3,--10'^8"San
SP,PN6259,N 2401915.0049,E 1317263.8323,EL270.82,--10'^8"San
SP,PN6260,N 2401891.9282,E 1317246.9357,EL271.12,--10'^8"San@FM
SP,PN6261,N 2401887.1183,E 1317243.4139,EL271.14,--10'^SMH10.0
SP,PN6262,N 2401890.0721,E 1317239.3797,EL271.14,--15'^SMH10.0
SP,PN6263,N 2402083.4533,E 1317541.5883,EL0.0,--Lat18
SP,PN6264,N 2402103.2311,E 1317556.0694,EL0.0,--Lat18
SP,PN6265,N 2402146.7688,E 1317445.922,EL0.0,--LatAdj
SP,PN6266,N 2402162.1405,E 1317424.9279,EL0.0,--LatAdj
SP,PN6267,N 2402196.3781,E 1317451.2606,EL271.15,--10^FC InlA26
SP,PN6268,N 2402184.5628,E 1317467.3975,EL271.15,--10^FC InlA26
SP,PN6269,N 2402198.5389,E 1317465.2367,EL271.15,--10^FC InlA26
SP,PN6270,N 2402166.8398,E 1317491.6028,EL270.8,--10^FC INLA27
SP,PN6271,N 2402178.6551,E 1317475.4659,EL270.8,--10^FC INLA27
SP,PN6272,N 2402180.8159,E 1317489.442,EL270.8,--10^FC INLA27
SP,PN6273,N 2402075.7786,E 1317424.9284,EL263.5,--10^FC INLA29
SP,PN6274,N 2402087.5292,E 1317408.7443,EL263.5,--10^FC INLA29
SP,PN6275,N 2402089.7223,E 1317422.744,EL263.5,--10^FC INLA29
SP,PN6276,N 2402093.4692,E 1317400.6995,EL273.0,--10^FC INLA28
SP,PN6277,N 2402105.2845,E 1317384.5626,EL273.0,--10^FC INLA28
SP,PN6278,N 2402091.3084,E 1317386.7234,EL273.0,--10^FC INLA28
SP,PN6279,N 2401855.1707,E 1317263.2816,EL275.6,--10^FC INLA25
SP,PN6280,N 2401867.1589,E 1317247.2728,EL275.6,--10^FC INLA25
SP,PN6281,N 2401853.1604,E 1317249.2831,EL275.6,--10^FC INLA25
SP,PN6282,N 2402147.0798,E 1316750.6939,EL274.96,--10^8"SAN
SP,PN6283,N 2402188.6656,E 1316722.9337,EL275.21,--10^8"SAN
SP,PN6284,N 2402230.2513,E 1316695.1735,EL275.46,--10^8"SAN
SP,PN6285,N 2402271.837,E 1316667.4133,EL275.71,--10^8"SAN
SP,PN6286,N 2402322.1279,E 1316639.8535,EL275.98,--15^SMH 7.1
SP,PN6287,N 2402319.3709,E 1316635.6823,EL275.98,--10^SMH 7.1
SP,PN6288,N 2402313.8567,E 1316627.34,EL275.98,--SMH 7.1
SP,PN6289,N 2402308.3425,E 1316618.9977,EL275.98,--10^SMH 7.1
SP,PN6290,N 2402305.5854,E 1316614.8266,EL275.98,--15^SMH 7.1
SP,PN6291,N 2402034.3893,E 1317393.3671,EL265.91,--10^36"Storm
SP,PN6292,N 2401994.0552,E 1317363.8177,EL268.12,--10^36"Storm
SP,PN6293,N 2401953.7212,E 1317334.2684,EL270.33,--10^36"Storm
SP,PN6294,N 2401913.3871,E 1317304.719,EL272.54,--10^36"Storm
SP,PN6295,N 2401873.0531,E 1317275.1696,EL274.75,--10^36"Storm
SP,PN6296,N 2402126.4977,E 1317462.0646,EL270.07,--10^18"Storm
SP,PN6297,N 2402440.7591,E 1316923.1433,EL0.0,--Corner
SP,PN6298,N 2402106.4723,E 1317379.2353,EL0.0,--Corner
SP,PN6299,N 2402267.841,E 1317497.3883,EL0.0,--Corner
SP,PN6300,N 2402504.9504,E 1317173.5534,EL0.0,--Corner
SP,PN6301,N 2402618.2691,E 1317336.3417,EL0.0,--Corner
SP,PN6302,N 2402419.2049,E 1317608.2157,EL0.0,--Corner
SP,PN6303,N 2402773.6132,E 1317867.7107,EL0.0,--Corner
SP,PN6304,N 2402395.0902,E 1318341.0499,EL0.0,--Corner
SP,PN6305,N 2401813.7379,E 1317974.7937,EL0.0,--Corner
SP,PN6306,N 2401530.2531,E 1318341.5126,EL0.0,--Corner
SP,PN6307,N 2401353.1683,E 1318218.9615,EL0.0,--Corner
SP,PN6308,N 2400831.2521,E 1317361.4356,EL0.0,--Corner
SP,PN6309,N 2401288.8573,E 1316758.3584,EL0.0,--Corner
SP,PN6310,N 2401746.4625,E 1316155.2812,EL0.0,--Corner
SP,PN6311,N 2401861.1692,E 1316656.2521,EL0.0,--LOD
SP,PN6312,N 2401878.9708,E 1316657.3697,EL0.0,--LOD
SP,PN6313,N 2401908.5215,E 1316670.5121,EL0.0,--LOD
SP,PN6314,N 2401935.2112,E 1316693.7677,EL0.0,--LOD
SP,PN6315,N 2402004.1972,E 1316744.7027,EL0.0,--LOD
SP,PN6316,N 2402030.6116,E 1316761.0593,EL0.0,--LOD
SP,PN6317,N 2402055.0642,E 1316780.8574,EL0.0,--LOD
SP,PN6318,N 2402072.4714,E 1316806.7144,EL0.0,--LOD
SP,PN6319,N 2402096.2556,E 1316838.6272,EL0.0,--LOD
SP,PN6320,N 2402083.3993,E 1316869.718,EL0.0,--LOD
SP,PN6321,N 2402052.2888,E 1316898.2848,EL0.0,--LOD
SP,PN6322,N 2401997.5161,E 1316904.4967,EL0.0,--LOD
SP,PN6323,N 2401954.1688,E 1316889.7475,EL0.0,--LOD
SP,PN6324,N 2401916.7912,E 1316914.628,EL0.0,--LOD
SP,PN6325,N 2401812.6255,E 1316945.3039,EL0.0,--LOD
SP,PN6326,N 2401747.9844,E 1316910.328,EL0.0,--LOD
SP,PN6327,N 2401718.8719,E 1316899.7345,EL0.0,--LOD
SP,PN6328,N 2401702.8709,E 1316886.1709,EL0.0,--LOD
SP,PN6329,N 2401707.8694,E 1316874.6202,EL0.0,--LOD
SP,PN6330,N 2401735.5826,E 1316840.8764,EL0.0,--LOD
SP,PN6331,N 2401730.1838,E 1316800.1818,EL0.0,--LOD
SP,PN6332,N 2401757.4894,E 1316763.0815,EL0.0,--LOD
SP,PN6333,N 2401785.0311,E 1316741.6592,EL0.0,--LOD
SP,PN6334,N 2401818.5361,E 1316694.5027,EL0.0,--LOD
SP,PN6335,N 2402323.493,E 1317035.2518,EL0.0,--LOD
SP,PN6336,N 2402306.9622,E 1317064.2238,EL0.0,--LOD
SP,PN6337,N 2402272.0827,E 1317096.3273,EL0.0,--LOD
SP,PN6338,N 2402251.0506,E 1317117.1065,EL0.0,--LOD
SP,PN6339,N 2402222.5869,E 1317165.3919,EL0.0,--LOD
SP,PN6340,N 2402193.6376,E 1317197.8684,EL0.0,--LOD
SP,PN6341,N 2402156.6723,E 1317185.8294,EL0.0,--LOD
SP,PN6342,N 2402155.3596,E 1317165.5301,EL0.0,--LOD
SP,PN6343,N 2402174.6816,E 1317116.8245,EL0.0,--LOD
SP,PN6344,N 2402237.4278,E 1317086.2801,EL0.0,--LOD
SP,PN6345,N 2402251.5628,E 1317051.2259,EL0.0,--LOD
SP,PN6346,N 2402274.2337,E 1317014.7567,EL0.0,--LOD
SP,PN6347,N 2402295.495,E 1317013.4394,EL0.0,--LOD
SP,PN6348,N 2401622.4756,E 1317012.7374,EL0.0,--LOD
SP,PN6349,N 2401639.059,E 1317024.433,EL0.0,--LOD
SP,PN6350,N 2401666.7557,E 1317050.7345,EL0.0,--LOD
SP,PN6351,N 2401696.6727,E 1317087.64,EL0.0,--LOD
SP,PN6352,N 2401737.7648,E 1317152.4954,EL0.0,--LOD
SP,PN6353,N 2401744.9324,E 1317172.5319,EL0.0,--LOD
SP,PN6354,N 2401782.026,E 1317206.2814,EL0.0,--LOD
SP,PN6355,N 2401838.8776,E 1317258.0418,EL0.0,--LOD
SP,PN6356,N 2401915.8573,E 1317315.5487,EL0.0,--LOD
SP,PN6357,N 2401841.8355,E 1317388.6801,EL0.0,--LOD
SP,PN6358,N 2401776.9034,E 1317455.4021,EL0.0,--LOD
SP,PN6359,N 2401722.8493,E 1317515.809,EL0.0,--LOD
SP,PN6360,N 2401673.719,E 1317421.3536,EL0.0,--LOD
SP,PN6361,N 2401627.6926,E 1317330.9135,EL0.0,--LOD
SP,PN6362,N 2401551.7257,E 1317256.7783,EL0.0,--LOD
SP,PN6363,N 2401473.3276,E 1317183.042,EL0.0,--LOD
SP,PN6364,N 2401520.8736,E 1317087.2973,EL0.0,--LOD
SP,PN6365,N 2401567.6946,E 1317026.4014,EL0.0,--LOD
SP,PN6366,N 2402082.0415,E 1317612.5529,EL0.0,--LOD
SP,PN6367,N 2402115.5786,E 1317637.2496,EL0.0,--LOD
SP,PN6368,N 2402119.6758,E 1317642.3245,EL0.0,--LOD
SP,PN6369,N 2402078.2412,E 1317699.9716,EL0.0,--LOD
SP,PN6370,N 2402041.6406,E 1317659.8313,EL0.0,--LOD
SP,PN6371,N 2402081.2069,E 1317787.4519,EL0.0,--LOD
SP,PN6372,N 2402143.7751,E 1317837.1222,EL0.0,--LOD
SP,PN6373,N 2402211.54,E 1317893.0497,EL0.0,--LOD
SP,PN6374,N 2402228.8707,E 1317906.7544,EL0.0,--LOD
SP,PN6375,N 2402227.5561,E 1317920.8278,EL0.0,--LOD
SP,PN6376,N 2402211.8634,E 1317932.8588,EL0.0,--LOD
SP,PN6377,N 2402172.8221,E 1317939.8382,EL0.0,--LOD
SP,PN6378,N 2402159.9518,E 1317950.2851,EL0.0,--LOD
SP,PN6379,N 2402167.4981,E 1317989.721,EL0.0,--LOD
SP,PN6380,N 2402159.3449,E 1318017.7794,EL0.0,--LOD
SP,PN6381,N 2402145.9251,E 1318018.4664,EL0.0,--LOD
SP,PN6382,N 2402101.4874,E 1317990.9053,EL0.0,--LOD
SP,PN6383,N 2402121.1466,E 1317958.3016,EL0.0,--LOD
SP,PN6384,N 2402106.2557,E 1317900.5148,EL0.0,--LOD
SP,PN6385,N 2402083.7842,E 1317877.0101,EL0.0,--LOD
SP,PN6386,N 2402055.0865,E 1317856.5272,EL0.0,--LOD
SP,PN6387,N 2401413.6229,E 1317166.0099,EL0.0,--cl path
SP,PN6388,N 2401423.3477,E 1317205.9976,EL0.0,--cl path
SP,PN6389,N 2401425.4138,E 1317224.9589,EL0.0,--cl path
SP,PN6390,N 2401425.4137,E 1317224.9644,EL0.0,--cl path
SP,PN6391,N 2401424.9077,E 1317246.6484,EL0.0,--cl path
SP,PN6392,N 2401435.8337,E 1317279.2213,EL0.0,--cl path
SP,PN6393,N 2401463.2717,E 1317310.5916,EL0.0,--cl path
SP,PN6394,N 2401494.1494,E 1317341.8897,EL0.0,--cl path
SP,PN6395,N 2401504.7153,E 1317352.5994,EL0.0,--cl path
SP,PN6396,N 2401549.3489,E 1317387.8727,EL0.0,--cl path
SP,PN6397,N 2401601.3026,E 1317446.8719,EL0.0,--cl path
SP,PN6398,N 2401635.2261,E 1317517.213,EL0.0,--cl path
SP,PN6399,N 2401667.8046,E 1317552.6785,EL0.0,--cl path
SP,PN6400,N 2401715.8849,E 1317561.4524,EL0.0,--cl path
SP,PN6401,N 2401728.6988,E 1317560.4634,EL0.0,--cl path
SP,PN6402,N 2401751.545,E 1317564.0907,EL0.0,--cl path
SP,PN6403,N 2401770.7537,E 1317576.6089,EL0.0,--cl path
SP,PN6404,N 2401777.6948,E 1317584.0386,EL0.0,--cl path
SP,PN6405,N 2401797.7313,E 1317615.882,EL0.0,--cl path
SP,PN6406,N 2401798.9702,E 1317624.8407,EL0.0,--cl path
SP,PN6407,N 2401791.4753,E 1317633.1776,EL0.0,--cl path
SP,PN6408,N 2401780.95,E 1317639.1832,EL0.0,--cl path
SP,PN6409,N 2401776.2396,E 1317670.7787,EL0.0,--cl path
SP,PN6410,N 2401791.8272,E 1317697.9059,EL0.0,--cl path
SP,PN6411,N 2401834.5895,E 1317748.9509,EL0.0,--cl path
SP,PN6412,N 2401853.3283,E 1317771.419,EL0.0,--cl path
SP,PN6413,N 2401877.4945,E 1317786.663,EL0.0,--cl path
SP,PN6414,N 2401923.0046,E 1317807.9196,EL0.0,--cl path
SP,PN6415,N 2401956.0085,E 1317832.7212,EL0.0,--cl path
SP,PN6416,N 2401985.7095,E 1317851.2454,EL0.0,--cl path
SP,PN6417,N 2402012.6597,E 1317842.9035,EL0.0,--cl path
SP,PN6418,N 2402026.4966,E 1317832.3738,EL0.0,--cl path
SP,PN6419,N 2402033.3456,E 1317833.1226,EL0.0,--cl path
SP,PN6420,N 2401814.1009,E 1316569.1664,EL291.31,--SMH 1.0
SP,PN6421,N 2401692.5022,E 1316579.7919,EL289.93,--SMH 2.0
SP,PN6422,N 2401546.827,E 1316729.901,EL286.42,--SMH 3.1
SP,PN6423,N 2401515.534,E 1316831.0334,EL282.34,--SMH 3.0
SP,PN6424,N 2401582.4861,E 1316955.9938,EL281.45,--SMH 4.0
SP,PN6425,N 2402000.7252,E 1316697.4948,EL284.38,--SMH 6.0
SP,PN6426,N 2402099.9421,E 1316770.137,EL274.51,--SMH 7.0
SP,PN6427,N 2402125.515,E 1316917.829,EL273.58,--SMH 8.0
SP,PN6428,N 2401947.7673,E 1317160.5818,EL271.89,--SMH 9.0
SP,PN6429,N 2401881.2106,E 1317251.4823,EL271.14,--SMH 10.0
SP,PN6430,N 2402151.1504,E 1317449.1302,EL267.5,--SMH 11.0
SP,PN6431,N 2401478.3727,E 1317159.3401,EL261.42,--SMH 4.1
SP,PN6432,N 2401461.9614,E 1317180.8805,EL250.88,--SMH 5.0
SP,PN6433,N 2401615.1954,E 1317334.3128,EL248.55,--SMH 5.2
SP,PN6434,N 2401715.9193,E 1317534.9997,EL243.4,--SMH 12.0
SP,PN6435,N 2401933.8475,E 1317745.9141,EL241.7,--SMH 20.1
SP,PN6436,N 2402012.6924,E 1317803.4755,EL241.03,--SMH 20.0
SP,PN6437,N 2402038.2389,E 1317938.1812,EL240.16,--SMH 19.0
SP,PN6438,N 2402043.1991,E 1317968.2188,EL243.59,--SMH 18.0
SP,PN6439,N 2402313.416,E 1318122.9499,EL251.8,--SMH 17.0
SP,PN6440,N 2402449.625,E 1317948.9938,EL255.91,--SMH 16.0
SP,PN6441,N 2402483.3171,E 1317790.0915,EL257.69,--SMH 15.0
SP,PN6442,N 2402443.6781,E 1317682.5664,EL265.13,--SMH 14
SP,PN6443,N 2402322.8801,E 1317574.8693,EL270.79,--SMH 13.0
SP,PN6444,N 2402313.8567,E 1316627.34,EL275.98,--smh 7.1
SP,PN6445,N 2402358.9093,E 1316567.3094,EL276.54,--smh 7.2
SP,PN6446,N 2402583.5995,E 1316732.0585,EL278.6,--smh 7.3
SP,PN6447,N 2401389.5879,E 1317108.4134,EL251.6,--SMH 33.2
SP,PN6448,N 2401248.9316,E 1317212.0757,EL252.66,--SMH 33.1
SP,PN6449,N 2402313.416,E 1318122.9499,EL251.8,--SMH 17
SP,PN6450,N 2402449.625,E 1317948.9938,EL255.91,--SMH 16
SP,PN6451,N 2402483.3171,E 1317790.0915,EL257.69,--SMH 15
SP,PN6452,N 2402443.6781,E 1317682.5664,EL265.13,--SMH 14
SP,PN6453,N 2402322.8801,E 1317574.8693,EL270.79,--SMH 13
SP,PN6454,N 2402151.1504,E 1317449.1302,EL267.5,--SMH 11
SP,PN6455,N 2401933.8475,E 1317745.9141,EL241.7,--SMH 20-1
SP,PN6456,N 2402012.6924,E 1317803.4755,EL241.03,--SMH 20
SP,PN6457,N 2402038.2389,E 1317938.1812,EL240.16,--SMH 19
SP,PN6458,N 2402043.1991,E 1317968.2188,EL243.59,--SMH 18
SP,PN6459,N 2401881.2106,E 1317251.4823,EL271.14,--SMH 10
SP,PN6460,N 2401947.7673,E 1317160.5818,EL271.8,--SMH 9
SP,PN6461,N 2402125.515,E 1316917.829,EL273.5,--SMH 8
SP,PN6462,N 2402099.9421,E 1316770.137,EL274.51,--SMH 7
SP,PN6463,N 2402000.7252,E 1316697.4948,EL284.38,--SMH 6
SP,PN6464,N 2402313.8567,E 1316627.34,EL275.98,--SMH 7-1
SP,PN6465,N 2402358.9093,E 1316567.3094,EL276.54,--SMH 7-2
SP,PN6466,N 2402583.5995,E 1316732.0585,EL278.6,--SMH 7-3
SP,PN6467,N 2401715.9193,E 1317534.9997,EL243.4,--SMH 12
SP,PN6468,N 2401615.1954,E 1317334.3128,EL248.55,--SMH 5-2
SP,PN6469,N 2401461.9614,E 1317180.8805,EL250.88,--SMH 5
SP,PN6470,N 2401478.3727,E 1317159.3401,EL261.42,--SMH 4-1
SP,PN6471,N 2401582.4861,E 1316955.9938,EL281.45,--SMH 4
SP,PN6472,N 2401515.534,E 1316831.0334,EL282.34,--SMH 3
SP,PN6473,N 2401546.827,E 1316729.901,EL286.42,--SMH 3-1
SP,PN6474,N 2401692.5022,E 1316579.7919,EL289.93,--SMH 2
SP,PN6475,N 2401814.1009,E 1316569.1664,EL291.31,--SMH 1
SP,PN6476,N 2402381.5205,E 1318035.9718,EL253.95,--MP SAN
SP,PN6477,N 2402466.4711,E 1317869.5426,EL256.9,--MP SAN
SP,PN6478,N 2402463.4976,E 1317736.3289,EL263.68,--MP SAN
SP,PN6479,N 2402383.2791,E 1317628.7179,EL268.06,--MP SAN
SP,PN6480,N 2402016.1805,E 1317350.3063,EL269.42,--MP SAN
SP,PN6481,N 2401914.489,E 1317206.0321,EL271.53,--MP SAN
SP,PN6482,N 2402036.6303,E 1317039.1976,EL272.76,--MP SAN
SP,PN6483,N 2402112.7286,E 1316843.983,EL274.15,--MP SAN
SP,PN6484,N 2402049.5268,E 1316733.2252,EL282.98,--MP SAN
SP,PN6485,N 2402206.8994,E 1316698.7385,EL275.35,--MP SAN
SP,PN6486,N 2402336.383,E 1316597.3247,EL276.36,--MP SAN
SP,PN6487,N 2402471.2544,E 1316649.684,EL277.66,--MP SAN
SP,PN6488,N 2401753.3011,E 1316574.474,EL290.72,--MP SAN
SP,PN6489,N 2401619.6646,E 1316654.8465,EL288.27,--MP SAN
SP,PN6490,N 2401531.1805,E 1316780.4672,EL285.88,--MP SAN
SP,PN6491,N 2401549.0101,E 1316893.5136,EL282.0,--MP SAN
SP,PN6492,N 2401530.4294,E 1317057.6669,EL271.54,--MP SAN
SP,PN6493,N 2401538.5784,E 1317257.5967,EL249.82,--MP SAN
SP,PN6494,N 2401665.5573,E 1317434.6562,EL246.08,--MP SAN
SP,PN6495,N 2401824.8834,E 1317640.4569,EL242.65,--MP SAN
SP,PN6496,N 2401973.27,E 1317774.6948,EL241.46,--MP SAN
SP,PN6497,N 2402025.4724,E 1317870.8271,EL240.7,--MP SAN
SP,PN6498,N 2402042.499,E 1317597.5222,EL256.7,--MP SAN
SP,PN6499,N 2402178.3076,E 1318045.5843,EL247.79,--MP SAN
SP,PN6500,N 2402378.4444,E 1318017.6151,EL253.02,--INL B7
SP,PN6501,N 2402155.2553,E 1317839.1337,EL251.41,--DMH 8
SP,PN6502,N 2401932.0662,E 1317660.6524,EL250.0,--HW 9
SP,PN6503,N 2402081.6539,E 1317416.8363,EL263.5,--INL A29
SP,PN6504,N 2402045.9652,E 1317465.9891,EL251.45,--DMH A30
SP,PN6505,N 2402014.3878,E 1317491.0714,EL250.0,--HW A31
SP,PN6506,N 2402267.6309,E 1317928.999,EL252.31,--MP STM
SP,PN6507,N 2402042.8798,E 1317749.2685,EL250.71,--MP STM
SP,PN6508,N 2401793.5909,E 1317515.364,EL250.0,--250 CONT
SP,PN6509,N 2401930.1209,E 1317435.0316,EL250.0,--250 CONT
SP,PN6510,N 2402019.6481,E 1317511.3947,EL250.0,--250 CONT
SP,PN6511,N 2401981.605,E 1317596.8429,EL250.0,--250 CONT
SP,PN6512,N 2401971.2048,E 1317622.9259,EL250.0,--250 CONT
SP,PN6513,N 2401930.0841,E 1317656.2478,EL250.0,--250 CONT
SP,PN6514,N 2401891.897,E 1317629.703,EL250.0,--250 CONT
SP,PN6515,N 2401858.0793,E 1317584.9081,EL250.0,--250 CONT
SP,PN6516,N 2401863.3417,E 1317470.8384,EL250.0,--250 CONT
SP,PN6517,N 2402005.5887,E 1317555.8563,EL250.0,--250 CONT
SP,PN6518,N 2401781.6637,E 1317533.8576,EL256.0,--256 CONT
SP,PN6519,N 2401775.5434,E 1317512.9997,EL256.0,--256 CONT
SP,PN6520,N 2401789.8653,E 1317493.1994,EL256.0,--256 CONT
SP,PN6521,N 2401907.2788,E 1317421.6701,EL256.0,--256 CONT
SP,PN6522,N 2401930.6257,E 1317416.8275,EL256.0,--256 CONT
SP,PN6523,N 2402172.7475,E 1317483.5344,EL270.8,--INLA27
SP,PN6524,N 2402190.4704,E 1317459.3291,EL271.15,--INLA26
SP,PN6525,N 2402081.6539,E 1317416.8363,EL263.5,--INLA29
SP,PN6526,N 2402099.3769,E 1317392.631,EL273.0,--INLA29
SP,PN6527,N 2401861.1648,E 1317255.2772,EL275.6,--INLA25
SP,PN6528,N 2402083.4239,E 1317895.7392,EL0.0,--12'^FM
SP,PN6529,N 2402072.3766,E 1317834.2451,EL0.0,--12'^FM
SP,PN6530,N 2402082.265,E 1317791.931,EL0.0,--12'^FM
SP,PN6531,N 2402092.1533,E 1317749.6168,EL0.0,--12'^FM
SP,PN6532,N 2402078.6879,E 1317723.009,EL0.0,--12'^FM
SP,PN6533,N 2402043.9701,E 1317698.1046,EL0.0,--12'^FM
SP,PN6534,N 2402009.2524,E 1317673.2003,EL0.0,--12'^FM
SP,PN6535,N 2401892.7924,E 1317252.5276,EL0.0,--12'^FM
SP,PN6536,N 2401918.79,E 1317217.0289,EL0.0,--12'^FM
SP,PN6537,N 2401948.3325,E 1317176.6898,EL0.0,--12'^FM
SP,PN6538,N 2401952.293,E 1317171.2818,EL0.0,--12'^FM
SP,PN6539,N 2401953.4502,E 1317169.7017,EL0.0,--12'^FM
SP,PN6540,N 2401958.177,E 1317163.2474,EL0.0,--12'^FM
SP,PN6541,N 2401959.3622,E 1317161.6291,EL0.0,--12'^FM
SP,PN6542,N 2402130.7143,E 1316927.6465,EL0.0,--12'^FM
SP,PN6543,N 2402134.5409,E 1316911.3442,EL0.0,--12'^FM
SP,PN6544,N 2402110.6157,E 1316773.1678,EL0.0,--12'^FM
SP,PN6545,N 2402101.9707,E 1316759.2285,EL0.0,--12'^FM
SP,PN6546,N 2401993.7669,E 1316680.0065,EL0.0,--12'^FM
SP,PN6547,N 2401953.424,E 1316650.4693,EL0.0,--12'^FM
SP,PN6548,N 2401924.4132,E 1316629.2288,EL0.0,--12'^FM
SP,PN6549,N 2401922.6843,E 1316618.048,EL0.0,--12'^FM
SP,PN6550,N 2401934.0768,E 1316602.4878,EL0.0,--12'^FM
SP,PN6551,N 2401963.6141,E 1316562.1448,EL0.0,--12'^FM
SP,PN6552,N 2401993.1513,E 1316521.8019,EL0.0,--12'^FM
SP,PN6553,N 2402022.6886,E 1316481.459,EL0.0,--12'^FM
SP,PN6554,N 2402052.2259,E 1316441.1161,EL0.0,--12'^FM
SP,PN6555,N 2402062.9576,E 1316426.4584,EL0.0,--12'^FM
SP,PN6556,N 2402058.7809,E 1316398.5068,EL0.0,--12'^FM
SP,PN6557,N 2402018.7284,E 1316368.5768,EL0.0,--12'^FM
SP,PN6558,N 2401978.676,E 1316338.6468,EL0.0,--12'^FM
SP,PN6559,N 2401938.6236,E 1316308.7168,EL0.0,--12'^FM
SP,PN6560,N 2401898.5712,E 1316278.7869,EL0.0,--12'^FM
SP,PN6561,N 2402047.271,E 1317942.7779,EL231.5,--WetWell-cut to S
SP,PN6562,N 2402045.3293,E 1317931.2773,EL231.5,--WetWell-cut to S
SP,PN6563,N 2402056.8299,E 1317929.3356,EL231.5,--WetWell-cut to S
SP,PN6564,N 2402058.7716,E 1317940.8362,EL231.5,--WetWell-cut to S
SP,PN6565,N 2402078.537,E 1317925.7853,EL242.67,--ValveVault-cut t
SP,PN6566,N 2402080.2018,E 1317935.6457,EL242.67,--ValveVault-cut t
SP,PN6567,N 2402074.2856,E 1317936.6446,EL242.67,--ValveVault-cut t
SP,PN6568,N 2402072.6208,E 1317926.7841,EL242.67,--ValveVault-cut t
SP,PN6569,N 2402065.8969,E 1317934.9868,EL244.75,--MidPoint-6"Pipe
SP,PN6570,N 2402065.4807,E 1317932.5217,EL244.75,--MidPoint-6"Pipe
SP,PN6571,N 2402110.0688,E 1316892.9022,EL283.4,--10'^CL InlA16
SP,PN6572,N 2401865.5337,E 1317207.5875,EL278.6,--10'^FC
SP,PN6573,N 2401858.0547,E 1317200.9494,EL278.6,--10^FC@CL InlA8
SP,PN6574,N 2401850.5757,E 1317194.3113,EL278.6,--10^FC
SP,PN6575,N 2401851.4165,E 1317208.4284,EL278.6,--FC @ CL InlA8
SP,PN6576,N 2401734.0243,E 1317133.2043,EL281.75,--10'^FC
SP,PN6577,N 2401728.4293,E 1317124.916,EL281.75,--10^FC @ CL InlA7
SP,PN6578,N 2401722.8344,E 1317116.6276,EL281.75,--10'^FC
SP,PN6579,N 2401736.7177,E 1317119.3211,EL281.75,--FC @ CL InlA7
SP,PN6580,N 2401717.6587,E 1317020.7604,EL284.05,--10'^FC
SP,PN6581,N 2401710.8637,E 1317013.4237,EL284.05,--10'^FC @ CL InlA
SP,PN6582,N 2401704.0686,E 1317006.087,EL284.05,--10'^FC
SP,PN6583,N 2401703.5269,E 1317020.2187,EL284.05,--FC @ CL InlA6
SP,PN6584,N 2401551.455,E 1316947.7438,EL287.1,--10'^FC
SP,PN6585,N 2401544.9325,E 1316940.1638,EL287.1,--10'^FC @ CL InlA
SP,PN6586,N 2401538.41,E 1316932.5837,EL287.1,--10'^FC
SP,PN6587,N 2401552.5126,E 1316933.6413,EL287.1,--FC @CL InlA5
SP,PN6588,N 2401507.3944,E 1316867.9811,EL288.35,--10'^FC
SP,PN6589,N 2401505.5584,E 1316858.1511,EL288.35,--10'^FC @ CL InlA
SP,PN6590,N 2401503.7223,E 1316848.3211,EL288.35,--10'^FC
SP,PN6591,N 2401515.3884,E 1316856.315,EL288.35,--FC @ CL InlA5
SP,PN6592,N 2401546.7201,E 1316860.6584,EL288.75,--10'^CL InlA4 @ F
SP,PN6593,N 2401544.8824,E 1316850.8287,EL288.75,--CL InlA4 @ FC
SP,PN6594,N 2401543.0447,E 1316840.999,EL288.75,--10'^CL InlA4 @ F
SP,PN6595,N 2401565.0267,E 1316770.7392,EL289.98,--10'^FC
SP,PN6596,N 2401570.1369,E 1316762.1435,EL289.98,--10'^@ CL InlA2.1
SP,PN6597,N 2401575.247,E 1316753.5478,EL289.98,--10'^FC
SP,PN6598,N 2401561.5412,E 1316757.0333,EL289.98,--FC @ CL InlA2.1
SP,PN6599,N 2401626.571,E 1316686.7164,EL291.6,--10'^FC
SP,PN6600,N 2401632.6313,E 1316678.762,EL291.6,--10'^FC @ CL InlA
SP,PN6601,N 2401638.6916,E 1316670.8076,EL291.6,--10'^FC
SP,PN6602,N 2401624.6769,E 1316672.7017,EL291.6,--FC @ CL InlA2
SP,PN6603,N 2401594.7534,E 1316662.4751,EL291.95,--10'^CL InlA1 @ F
SP,PN6604,N 2401600.8137,E 1316654.5207,EL291.95,--CL InlA1 @ FC
SP,PN6605,N 2401606.874,E 1316646.5663,EL291.95,--10'^CL InlA1 @ F
SP,PN6606,N 2402111.3056,E 1316882.9789,EL283.4,--CL Inla16 @ FC
SP,PN6607,N 2402112.5425,E 1316873.0557,EL283.4,--10' CL InlA16
SP,PN6608,N 2402149.7616,E 1316897.8496,EL282.3,--10'^FC
SP,PN6609,N 2402150.9985,E 1316887.9264,EL282.3,--10'^@CL InlA17
SP,PN6610,N 2402152.2354,E 1316878.0032,EL282.3,--10'^FC
SP,PN6611,N 2402112.7947,E 1316960.5846,EL282.0,--10'^CL InlA18
SP,PN6612,N 2402106.887,E 1316968.653,EL282.0,--CL InlA18 @ FC
SP,PN6613,N 2402100.9794,E 1316976.7214,EL282.0,--10'^InlA18 @ FC
SP,PN6614,N 2402080.5209,E 1316936.954,EL280.6,--10'^ FC
SP,PN6615,N 2402074.6133,E 1316945.0224,EL280.6,--10'^CL InlA19
SP,PN6616,N 2402068.7056,E 1316953.0909,EL280.6,--10'^FC
SP,PN6617,N 2402082.6817,E 1316950.9301,EL280.6,--FC @ CL InlA19
SP,PN6618,N 2401989.2983,E 1317061.5423,EL278.75,--10'^FC
SP,PN6619,N 2401983.3906,E 1317069.6108,EL278.75,--10'^CL InlA21
SP,PN6620,N 2401977.483,E 1317077.6792,EL278.75,--10'^FC
SP,PN6621,N 2401991.4591,E 1317075.5184,EL278.75,--FC @CL InlA21
SP,PN6622,N 2402021.572,E 1317085.1729,EL280.35,--10'^InlA20 @FC
SP,PN6623,N 2402015.6644,E 1317093.2414,EL280.35,--CL InlA20 @ FC
SP,PN6624,N 2402009.7567,E 1317101.3098,EL280.35,--10'InlA20 @ FC
SP,PN6625,N 2401927.3756,E 1317213.8228,EL27870.0,--10'CL InlA22
SP,PN6626,N 2401921.4679,E 1317221.8913,EL278.7,--CL InlA22 @ FC
SP,PN6627,N 2401915.5603,E 1317229.9597,EL278.7,--10'^CL InlA22
SP,PN6628,N 2401898.8402,E 1317202.0138,EL278.4,--CL DOUBLE InlA24
SP,PN6629,N 2401896.6811,E 1317188.0368,EL278.4,--10'^FC
SP,PN6630,N 2401890.7727,E 1317196.1047,EL278.4,--10'^CL DOUBLE In
SP,PN6631,N 2401884.8631,E 1317204.1717,EL278.4,--10'^FC
`.trim();